import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
import $ from '../../utils/ajax';
function get_stock_stat(_x) {
  return _get_stock_stat.apply(this, arguments);
}
function _get_stock_stat() {
  _get_stock_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", $.getJSON("/v1/company/get_stock_stat/", params));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _get_stock_stat.apply(this, arguments);
}
function get_stock_list(_x2) {
  return _get_stock_list.apply(this, arguments);
}
function _get_stock_list() {
  _get_stock_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", $.getJSON("/v1/company/get_stock_list/", params));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _get_stock_list.apply(this, arguments);
}
function getDeviceList(_x3) {
  return _getDeviceList.apply(this, arguments);
}
function _getDeviceList() {
  _getDeviceList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", $.getJSON("/v1/company/get_device_list/", params));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getDeviceList.apply(this, arguments);
}
function update_devices(_x4) {
  return _update_devices.apply(this, arguments);
}
function _update_devices() {
  _update_devices = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context4.abrupt("return", $.formPost("/v1/company/update_devices/", formData));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _update_devices.apply(this, arguments);
}
function update_device(_x5) {
  return _update_device.apply(this, arguments);
}
function _update_device() {
  _update_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", $.post("/v1/company/update_device/", params));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _update_device.apply(this, arguments);
}
function deleteStock(_x6) {
  return _deleteStock.apply(this, arguments);
}
function _deleteStock() {
  _deleteStock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", $.post("/v1/company/delete_stock/", params));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _deleteStock.apply(this, arguments);
}
function create_stock(_x7) {
  return _create_stock.apply(this, arguments);
}
function _create_stock() {
  _create_stock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", $.post("/v1/company/create_stock/", params));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _create_stock.apply(this, arguments);
}
function get_room_list(_x8) {
  return _get_room_list.apply(this, arguments);
}
function _get_room_list() {
  _get_room_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", $.getJSON("/v1/company/get_room_list/", params));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _get_room_list.apply(this, arguments);
}
function get_company_list(_x9) {
  return _get_company_list.apply(this, arguments);
}
function _get_company_list() {
  _get_company_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", $.getJSON("/v1/company/get_company_list/", params));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _get_company_list.apply(this, arguments);
}
function get_agency_list(_x10) {
  return _get_agency_list.apply(this, arguments);
}
function _get_agency_list() {
  _get_agency_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", $.getJSON("/v1/company/get_agency_list_new/", params));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _get_agency_list.apply(this, arguments);
}
function get_agency_list_all(_x11) {
  return _get_agency_list_all.apply(this, arguments);
}
function _get_agency_list_all() {
  _get_agency_list_all = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", $.getJSON("/v1/company/get_agency_list/", params));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _get_agency_list_all.apply(this, arguments);
}
function out_stock(_x12) {
  return _out_stock.apply(this, arguments);
}
function _out_stock() {
  _out_stock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", $.post("/v1/company/out_stock/", params));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _out_stock.apply(this, arguments);
}
function update_stock(_x13) {
  return _update_stock.apply(this, arguments);
}
function _update_stock() {
  _update_stock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", $.post("/v1/company/update_stock/", params));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _update_stock.apply(this, arguments);
}
function getRoomList(_x14) {
  return _getRoomList.apply(this, arguments);
}
function _getRoomList() {
  _getRoomList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(params) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", $.getJSON("/v1/company/get_room_list/", params));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _getRoomList.apply(this, arguments);
}
function create_room(_x15) {
  return _create_room.apply(this, arguments);
}
function _create_room() {
  _create_room = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(params) {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", $.post("/v1/company/create_room/", params));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _create_room.apply(this, arguments);
}
function update_room(_x16) {
  return _update_room.apply(this, arguments);
}
function _update_room() {
  _update_room = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", $.post("/v1/company/update_room/", params));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _update_room.apply(this, arguments);
}
function get_isp_list(_x17) {
  return _get_isp_list.apply(this, arguments);
}
function _get_isp_list() {
  _get_isp_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", $.getJSON("/v1/company/get_isp_list/", params));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _get_isp_list.apply(this, arguments);
}
function update_isp(_x18) {
  return _update_isp.apply(this, arguments);
}
function _update_isp() {
  _update_isp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(params) {
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          return _context18.abrupt("return", $.post("/v1/company/update_isp/", params));
        case 1:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _update_isp.apply(this, arguments);
}
function create_isp(_x19) {
  return _create_isp.apply(this, arguments);
}
function _create_isp() {
  _create_isp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(params) {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", $.post("/v1/company/create_isp/", params));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _create_isp.apply(this, arguments);
}
function delete_isp(_x20) {
  return _delete_isp.apply(this, arguments);
}
function _delete_isp() {
  _delete_isp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(params) {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", $.post("/v1/company/delete_isp/", params));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _delete_isp.apply(this, arguments);
}
function delete_room(_x21) {
  return _delete_room.apply(this, arguments);
}
function _delete_room() {
  _delete_room = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(params) {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", $.post("/v1/company/delete_room/", params));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _delete_room.apply(this, arguments);
}
function get_black_list(_x22) {
  return _get_black_list.apply(this, arguments);
}
function _get_black_list() {
  _get_black_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(params) {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", $.getJSON("/v1/company/get_black_list/", params));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _get_black_list.apply(this, arguments);
}
function delete_black_list(_x23) {
  return _delete_black_list.apply(this, arguments);
}
function _delete_black_list() {
  _delete_black_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(params) {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", $.post("/v1/company/delete_black_list/", params));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _delete_black_list.apply(this, arguments);
}
function create_black_list(_x24) {
  return _create_black_list.apply(this, arguments);
}
function _create_black_list() {
  _create_black_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(params) {
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", $.post("/v1/company/create_black_list/", params));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _create_black_list.apply(this, arguments);
}
function get_link_list(_x25) {
  return _get_link_list.apply(this, arguments);
}
function _get_link_list() {
  _get_link_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(params) {
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", $.getJSON("/v1/company/get_link_list/", params));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _get_link_list.apply(this, arguments);
}
function get_link_stat(_x26) {
  return _get_link_stat.apply(this, arguments);
}
function _get_link_stat() {
  _get_link_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(params) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", $.getJSON("/v1/company/get_link_stat/", params));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _get_link_stat.apply(this, arguments);
}
function get_link(_x27) {
  return _get_link.apply(this, arguments);
}
function _get_link() {
  _get_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(params) {
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", $.getJSON("/v1/company/get_link/", params));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _get_link.apply(this, arguments);
}
function get_device_list(_x28) {
  return _get_device_list.apply(this, arguments);
}
function _get_device_list() {
  _get_device_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(params) {
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", $.getJSON("/v1/company/get_device_list/", params));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _get_device_list.apply(this, arguments);
}
function create_link(_x29) {
  return _create_link.apply(this, arguments);
}
function _create_link() {
  _create_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(params) {
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", $.post("/v1/company/create_link/", params));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _create_link.apply(this, arguments);
}
function update_link(_x30) {
  return _update_link.apply(this, arguments);
}
function _update_link() {
  _update_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(params) {
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", $.post("/v1/company/update_link/", params));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _update_link.apply(this, arguments);
}
function delete_link(_x31) {
  return _delete_link.apply(this, arguments);
}
function _delete_link() {
  _delete_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(params) {
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", $.post("/v1/company/delete_link/", params));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _delete_link.apply(this, arguments);
}
function batch_update_company(_x32) {
  return _batch_update_company.apply(this, arguments);
}
function _batch_update_company() {
  _batch_update_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(params) {
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", $.post("/v1/company/batch_update_company/", params));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _batch_update_company.apply(this, arguments);
}
function create_topo(_x33) {
  return _create_topo.apply(this, arguments);
}
function _create_topo() {
  _create_topo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context33.abrupt("return", $.formPost("/v1/company/create_topo/", formData));
        case 3:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _create_topo.apply(this, arguments);
}
function delete_topo(_x34) {
  return _delete_topo.apply(this, arguments);
}
function _delete_topo() {
  _delete_topo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(params) {
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", $.getJSON("/v1/company/delete_topo/", params));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _delete_topo.apply(this, arguments);
}
function delete_topo_batch(_x35) {
  return _delete_topo_batch.apply(this, arguments);
}
function _delete_topo_batch() {
  _delete_topo_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(params) {
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", $.getJSON("/v1/company/delete_topo_batch/", params));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _delete_topo_batch.apply(this, arguments);
}
function get_link_path(_x36) {
  return _get_link_path.apply(this, arguments);
}
function _get_link_path() {
  _get_link_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(params) {
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", $.getJSON("/v1/company/get_link_path/", params));
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _get_link_path.apply(this, arguments);
}
function get_speed_rule(_x37) {
  return _get_speed_rule.apply(this, arguments);
}
function _get_speed_rule() {
  _get_speed_rule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(params) {
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", $.getJSON("/v1/company/get_speed_rule/", params));
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _get_speed_rule.apply(this, arguments);
}
function create_link_batch(_x38) {
  return _create_link_batch.apply(this, arguments);
}
function _create_link_batch() {
  _create_link_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(params) {
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", $.post("/v1/company/create_link_batch/", params));
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _create_link_batch.apply(this, arguments);
}
function delete_agency_batch(_x39) {
  return _delete_agency_batch.apply(this, arguments);
}
function _delete_agency_batch() {
  _delete_agency_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(params) {
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", $.getJSON("/v1/company/delete_agency_batch/", params));
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _delete_agency_batch.apply(this, arguments);
}
function delete_agency(_x40) {
  return _delete_agency.apply(this, arguments);
}
function _delete_agency() {
  _delete_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(params) {
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", $.post("/v1/company/delete_agency/", params));
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _delete_agency.apply(this, arguments);
}
function create_agency(_x41) {
  return _create_agency.apply(this, arguments);
}
function _create_agency() {
  _create_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(params) {
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", $.post("/v1/company/create_agency/", params));
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _create_agency.apply(this, arguments);
}
function get_iptable_list(_x42) {
  return _get_iptable_list.apply(this, arguments);
}
function _get_iptable_list() {
  _get_iptable_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(params) {
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", $.getJSON("/v1/company/get_iptable_list/", params));
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _get_iptable_list.apply(this, arguments);
}
function create_iptable(_x43) {
  return _create_iptable.apply(this, arguments);
}
function _create_iptable() {
  _create_iptable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key] || "");
          }
          return _context43.abrupt("return", $.formPost("/v1/company/create_iptable/", formData));
        case 3:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _create_iptable.apply(this, arguments);
}
function delete_iptable(_x44) {
  return _delete_iptable.apply(this, arguments);
}
function _delete_iptable() {
  _delete_iptable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(params) {
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", $.post("/v1/company/delete_iptable/", params));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _delete_iptable.apply(this, arguments);
}
function get_device_stat(_x45) {
  return _get_device_stat.apply(this, arguments);
}
function _get_device_stat() {
  _get_device_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(params) {
    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", $.getJSON("/v1/company/get_device_stat/", params));
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _get_device_stat.apply(this, arguments);
}
function get_wan_info(_x46) {
  return _get_wan_info.apply(this, arguments);
}
function _get_wan_info() {
  _get_wan_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46(params) {
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", $.getJSON("/v1/company/get_wan_info/", params));
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _get_wan_info.apply(this, arguments);
}
function delete_device(_x47) {
  return _delete_device.apply(this, arguments);
}
function _delete_device() {
  _delete_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(params) {
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", $.post("/v1/company/delete_device/", params));
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _delete_device.apply(this, arguments);
}
function get_topo_list(_x48) {
  return _get_topo_list.apply(this, arguments);
}
function _get_topo_list() {
  _get_topo_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(params) {
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", $.getJSON("/v1/company/get_topo_list/", params));
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _get_topo_list.apply(this, arguments);
}
function get_manual_link_path_example(_x49) {
  return _get_manual_link_path_example.apply(this, arguments);
}
function _get_manual_link_path_example() {
  _get_manual_link_path_example = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(params) {
    return _regeneratorRuntime().wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          return _context49.abrupt("return", $.getJSON("/v1/company/get_manual_link_path_example/", params));
        case 1:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return _get_manual_link_path_example.apply(this, arguments);
}
function create_manual_link_path(_x50) {
  return _create_manual_link_path.apply(this, arguments);
}
function _create_manual_link_path() {
  _create_manual_link_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(params) {
    return _regeneratorRuntime().wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          return _context50.abrupt("return", $.post("/v1/company/create_manual_link_path/", params));
        case 1:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return _create_manual_link_path.apply(this, arguments);
}
function get_deduplication(_x51) {
  return _get_deduplication.apply(this, arguments);
}
function _get_deduplication() {
  _get_deduplication = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(params) {
    return _regeneratorRuntime().wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          return _context51.abrupt("return", $.getJSON("/v1/company/get_deduplication/", params));
        case 1:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));
  return _get_deduplication.apply(this, arguments);
}
function update_deduplication(_x52) {
  return _update_deduplication.apply(this, arguments);
}
function _update_deduplication() {
  _update_deduplication = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(params) {
    return _regeneratorRuntime().wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          return _context52.abrupt("return", $.post("/v1/company/update_deduplication/", params));
        case 1:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return _update_deduplication.apply(this, arguments);
}
function get_company_related_person(_x53) {
  return _get_company_related_person.apply(this, arguments);
}
function _get_company_related_person() {
  _get_company_related_person = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(params) {
    return _regeneratorRuntime().wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          return _context53.abrupt("return", $.getJSON("/v1/company/get_company_related_person/", params));
        case 1:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return _get_company_related_person.apply(this, arguments);
}
function get_company_stat(_x54) {
  return _get_company_stat.apply(this, arguments);
}
function _get_company_stat() {
  _get_company_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(params) {
    return _regeneratorRuntime().wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          return _context54.abrupt("return", $.getJSON("/v1/company/get_company_stat/", params));
        case 1:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return _get_company_stat.apply(this, arguments);
}
function updateRelatedPerson(_x55) {
  return _updateRelatedPerson.apply(this, arguments);
}
function _updateRelatedPerson() {
  _updateRelatedPerson = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee55$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context55.abrupt("return", $.formPost("/v1/company/update_related_person/", formData));
        case 3:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return _updateRelatedPerson.apply(this, arguments);
}
function update_company(_x56) {
  return _update_company.apply(this, arguments);
}
function _update_company() {
  _update_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56(params) {
    return _regeneratorRuntime().wrap(function _callee56$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          return _context56.abrupt("return", $.post("/v1/company/update_company/", params));
        case 1:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return _update_company.apply(this, arguments);
}
function get_related_person_list(_x57) {
  return _get_related_person_list.apply(this, arguments);
}
function _get_related_person_list() {
  _get_related_person_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(params) {
    return _regeneratorRuntime().wrap(function _callee57$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          return _context57.abrupt("return", $.getJSON("/v1/company/get_related_person_list/", params));
        case 1:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return _get_related_person_list.apply(this, arguments);
}
function create_company(_x58) {
  return _create_company.apply(this, arguments);
}
function _create_company() {
  _create_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(params) {
    return _regeneratorRuntime().wrap(function _callee58$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          return _context58.abrupt("return", $.post("/v1/company/create_company/", params));
        case 1:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return _create_company.apply(this, arguments);
}
function create_company_related_person(_x59) {
  return _create_company_related_person.apply(this, arguments);
}
function _create_company_related_person() {
  _create_company_related_person = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59(params) {
    return _regeneratorRuntime().wrap(function _callee59$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          return _context59.abrupt("return", $.post("/v1/company/create_company_related_person/", params));
        case 1:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return _create_company_related_person.apply(this, arguments);
}
function create_company_contract(_x60) {
  return _create_company_contract.apply(this, arguments);
}
function _create_company_contract() {
  _create_company_contract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee60$(_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context60.abrupt("return", $.formPost("/v1/company/create_company_contract/", formData));
        case 3:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return _create_company_contract.apply(this, arguments);
}
function update_contract(_x61) {
  return _update_contract.apply(this, arguments);
}
function _update_contract() {
  _update_contract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee61$(_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context61.abrupt("return", $.formPost("/v1/company/update_contract/", formData));
        case 3:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return _update_contract.apply(this, arguments);
}
function delete_attachment(_x62) {
  return _delete_attachment.apply(this, arguments);
}
function _delete_attachment() {
  _delete_attachment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(params) {
    return _regeneratorRuntime().wrap(function _callee62$(_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          return _context62.abrupt("return", $.getJSON("/v1/company/delete_attachment/", params));
        case 1:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return _delete_attachment.apply(this, arguments);
}
function get_contract_list(_x63) {
  return _get_contract_list.apply(this, arguments);
}
function _get_contract_list() {
  _get_contract_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(params) {
    return _regeneratorRuntime().wrap(function _callee63$(_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          return _context63.abrupt("return", $.getJSON("/v1/company/get_contract_list/", params));
        case 1:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return _get_contract_list.apply(this, arguments);
}
function update_speed_rule(_x64) {
  return _update_speed_rule.apply(this, arguments);
}
function _update_speed_rule() {
  _update_speed_rule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64(params) {
    return _regeneratorRuntime().wrap(function _callee64$(_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          return _context64.abrupt("return", $.post("/v1/company/update_speed_rule/", params));
        case 1:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return _update_speed_rule.apply(this, arguments);
}
function delete_company(_x65) {
  return _delete_company.apply(this, arguments);
}
function _delete_company() {
  _delete_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65(params) {
    return _regeneratorRuntime().wrap(function _callee65$(_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          return _context65.abrupt("return", $.post("/v1/company/delete_company/", params));
        case 1:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return _delete_company.apply(this, arguments);
}
function create_related_person(_x66) {
  return _create_related_person.apply(this, arguments);
}
function _create_related_person() {
  _create_related_person = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66(params) {
    return _regeneratorRuntime().wrap(function _callee66$(_context66) {
      while (1) switch (_context66.prev = _context66.next) {
        case 0:
          return _context66.abrupt("return", $.post("/v1/company/create_related_person/", params));
        case 1:
        case "end":
          return _context66.stop();
      }
    }, _callee66);
  }));
  return _create_related_person.apply(this, arguments);
}
function delete_related_person(_x67) {
  return _delete_related_person.apply(this, arguments);
}
function _delete_related_person() {
  _delete_related_person = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67(params) {
    return _regeneratorRuntime().wrap(function _callee67$(_context67) {
      while (1) switch (_context67.prev = _context67.next) {
        case 0:
          return _context67.abrupt("return", $.post("/v1/company/delete_related_person/", params));
        case 1:
        case "end":
          return _context67.stop();
      }
    }, _callee67);
  }));
  return _delete_related_person.apply(this, arguments);
}
function add_department(_x68) {
  return _add_department.apply(this, arguments);
}
function _add_department() {
  _add_department = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68(params) {
    return _regeneratorRuntime().wrap(function _callee68$(_context68) {
      while (1) switch (_context68.prev = _context68.next) {
        case 0:
          return _context68.abrupt("return", $.post("/v1/company/add_department/", params));
        case 1:
        case "end":
          return _context68.stop();
      }
    }, _callee68);
  }));
  return _add_department.apply(this, arguments);
}
function delete_department(_x69) {
  return _delete_department.apply(this, arguments);
}
function _delete_department() {
  _delete_department = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69(params) {
    return _regeneratorRuntime().wrap(function _callee69$(_context69) {
      while (1) switch (_context69.prev = _context69.next) {
        case 0:
          return _context69.abrupt("return", $.post("/v1/company/delete_department/", params));
        case 1:
        case "end":
          return _context69.stop();
      }
    }, _callee69);
  }));
  return _delete_department.apply(this, arguments);
}
function change_activity(_x70) {
  return _change_activity.apply(this, arguments);
}
function _change_activity() {
  _change_activity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70(params) {
    return _regeneratorRuntime().wrap(function _callee70$(_context70) {
      while (1) switch (_context70.prev = _context70.next) {
        case 0:
          return _context70.abrupt("return", $.post("/v1/company/change_activity/", params, undefined, "", true));
        case 1:
        case "end":
          return _context70.stop();
      }
    }, _callee70);
  }));
  return _change_activity.apply(this, arguments);
}
function update_department(_x71) {
  return _update_department.apply(this, arguments);
}
function _update_department() {
  _update_department = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71(params) {
    return _regeneratorRuntime().wrap(function _callee71$(_context71) {
      while (1) switch (_context71.prev = _context71.next) {
        case 0:
          return _context71.abrupt("return", $.post("/v1/company/update_department/", params));
        case 1:
        case "end":
          return _context71.stop();
      }
    }, _callee71);
  }));
  return _update_department.apply(this, arguments);
}
function reset_password(_x72) {
  return _reset_password.apply(this, arguments);
}
function _reset_password() {
  _reset_password = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72(params) {
    return _regeneratorRuntime().wrap(function _callee72$(_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          return _context72.abrupt("return", $.post("/v1/company/reset_password/", params));
        case 1:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
  return _reset_password.apply(this, arguments);
}
function get_dep_tree(_x73) {
  return _get_dep_tree.apply(this, arguments);
}
function _get_dep_tree() {
  _get_dep_tree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73(params) {
    return _regeneratorRuntime().wrap(function _callee73$(_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          return _context73.abrupt("return", $.getJSON("/v1/company/get_dep_tree/", params));
        case 1:
        case "end":
          return _context73.stop();
      }
    }, _callee73);
  }));
  return _get_dep_tree.apply(this, arguments);
}
function update_password(_x74) {
  return _update_password.apply(this, arguments);
}
function _update_password() {
  _update_password = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74(params) {
    return _regeneratorRuntime().wrap(function _callee74$(_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          return _context74.abrupt("return", $.post("/v1/company/update_device_root_sn/", params));
        case 1:
        case "end":
          return _context74.stop();
      }
    }, _callee74);
  }));
  return _update_password.apply(this, arguments);
}
function get_isp_dict(_x75) {
  return _get_isp_dict.apply(this, arguments);
}
function _get_isp_dict() {
  _get_isp_dict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75(params) {
    return _regeneratorRuntime().wrap(function _callee75$(_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          return _context75.abrupt("return", $.getJSON("/v1/company/get_isp_dict/", params));
        case 1:
        case "end":
          return _context75.stop();
      }
    }, _callee75);
  }));
  return _get_isp_dict.apply(this, arguments);
}
function update_isp_dict(_x76) {
  return _update_isp_dict.apply(this, arguments);
}
function _update_isp_dict() {
  _update_isp_dict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76(params) {
    return _regeneratorRuntime().wrap(function _callee76$(_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          return _context76.abrupt("return", $.post("/v1/company/update_isp_dict/", params));
        case 1:
        case "end":
          return _context76.stop();
      }
    }, _callee76);
  }));
  return _update_isp_dict.apply(this, arguments);
}
function add_isp_dict(_x77) {
  return _add_isp_dict.apply(this, arguments);
}
function _add_isp_dict() {
  _add_isp_dict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77(params) {
    return _regeneratorRuntime().wrap(function _callee77$(_context77) {
      while (1) switch (_context77.prev = _context77.next) {
        case 0:
          return _context77.abrupt("return", $.post("/v1/company/add_isp_dict/", params));
        case 1:
        case "end":
          return _context77.stop();
      }
    }, _callee77);
  }));
  return _add_isp_dict.apply(this, arguments);
}
function delete_isp_dict(_x78) {
  return _delete_isp_dict.apply(this, arguments);
}
function _delete_isp_dict() {
  _delete_isp_dict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78(params) {
    return _regeneratorRuntime().wrap(function _callee78$(_context78) {
      while (1) switch (_context78.prev = _context78.next) {
        case 0:
          return _context78.abrupt("return", $.post("/v1/company/delete_isp_dict/", params));
        case 1:
        case "end":
          return _context78.stop();
      }
    }, _callee78);
  }));
  return _delete_isp_dict.apply(this, arguments);
}
function update_stock_batch(_x79) {
  return _update_stock_batch.apply(this, arguments);
}
function _update_stock_batch() {
  _update_stock_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79(params) {
    return _regeneratorRuntime().wrap(function _callee79$(_context79) {
      while (1) switch (_context79.prev = _context79.next) {
        case 0:
          return _context79.abrupt("return", $.post("/v1/company/update_stock_batch/", params));
        case 1:
        case "end":
          return _context79.stop();
      }
    }, _callee79);
  }));
  return _update_stock_batch.apply(this, arguments);
}
function get_sn(_x80) {
  return _get_sn.apply(this, arguments);
}
function _get_sn() {
  _get_sn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80(params) {
    return _regeneratorRuntime().wrap(function _callee80$(_context80) {
      while (1) switch (_context80.prev = _context80.next) {
        case 0:
          return _context80.abrupt("return", $.getJSON("/v1/company/get_sn/", params));
        case 1:
        case "end":
          return _context80.stop();
      }
    }, _callee80);
  }));
  return _get_sn.apply(this, arguments);
}
function get_app_category(_x81) {
  return _get_app_category.apply(this, arguments);
}
function _get_app_category() {
  _get_app_category = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81(params) {
    return _regeneratorRuntime().wrap(function _callee81$(_context81) {
      while (1) switch (_context81.prev = _context81.next) {
        case 0:
          return _context81.abrupt("return", $.getJSON("/v1/company/get_app_category/", params));
        case 1:
        case "end":
          return _context81.stop();
      }
    }, _callee81);
  }));
  return _get_app_category.apply(this, arguments);
}
function get_dpi_apps_custom(_x82) {
  return _get_dpi_apps_custom.apply(this, arguments);
}
function _get_dpi_apps_custom() {
  _get_dpi_apps_custom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82(params) {
    return _regeneratorRuntime().wrap(function _callee82$(_context82) {
      while (1) switch (_context82.prev = _context82.next) {
        case 0:
          return _context82.abrupt("return", $.getJSON("/v1/company/get_dpi_apps_custom/", params));
        case 1:
        case "end":
          return _context82.stop();
      }
    }, _callee82);
  }));
  return _get_dpi_apps_custom.apply(this, arguments);
}
function create_dpi_apps_custom(_x83) {
  return _create_dpi_apps_custom.apply(this, arguments);
}
function _create_dpi_apps_custom() {
  _create_dpi_apps_custom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83(params) {
    return _regeneratorRuntime().wrap(function _callee83$(_context83) {
      while (1) switch (_context83.prev = _context83.next) {
        case 0:
          return _context83.abrupt("return", $.post("/v1/company/create_dpi_apps_custom/", params));
        case 1:
        case "end":
          return _context83.stop();
      }
    }, _callee83);
  }));
  return _create_dpi_apps_custom.apply(this, arguments);
}
function update_dpi_apps_custom(_x84) {
  return _update_dpi_apps_custom.apply(this, arguments);
}
function _update_dpi_apps_custom() {
  _update_dpi_apps_custom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84(params) {
    return _regeneratorRuntime().wrap(function _callee84$(_context84) {
      while (1) switch (_context84.prev = _context84.next) {
        case 0:
          return _context84.abrupt("return", $.post("/v1/company/update_dpi_apps_custom/", params));
        case 1:
        case "end":
          return _context84.stop();
      }
    }, _callee84);
  }));
  return _update_dpi_apps_custom.apply(this, arguments);
}
function delete_dpi_apps_custom(_x85) {
  return _delete_dpi_apps_custom.apply(this, arguments);
}
function _delete_dpi_apps_custom() {
  _delete_dpi_apps_custom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85(params) {
    return _regeneratorRuntime().wrap(function _callee85$(_context85) {
      while (1) switch (_context85.prev = _context85.next) {
        case 0:
          return _context85.abrupt("return", $.post("/v1/company/delete_dpi_apps_custom/", params));
        case 1:
        case "end":
          return _context85.stop();
      }
    }, _callee85);
  }));
  return _delete_dpi_apps_custom.apply(this, arguments);
}
function get_dpi_apps(_x86) {
  return _get_dpi_apps.apply(this, arguments);
}
function _get_dpi_apps() {
  _get_dpi_apps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee86(params) {
    return _regeneratorRuntime().wrap(function _callee86$(_context86) {
      while (1) switch (_context86.prev = _context86.next) {
        case 0:
          return _context86.abrupt("return", $.getJSON("/v1/company/get_dpi_apps/", params));
        case 1:
        case "end":
          return _context86.stop();
      }
    }, _callee86);
  }));
  return _get_dpi_apps.apply(this, arguments);
}
function get_tunnel_port(_x87, _x88) {
  return _get_tunnel_port.apply(this, arguments);
}
function _get_tunnel_port() {
  _get_tunnel_port = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee87(params, loadingText) {
    return _regeneratorRuntime().wrap(function _callee87$(_context87) {
      while (1) switch (_context87.prev = _context87.next) {
        case 0:
          return _context87.abrupt("return", $.getJSON("/v1/company/get_tunnel_port/", params, loadingText));
        case 1:
        case "end":
          return _context87.stop();
      }
    }, _callee87);
  }));
  return _get_tunnel_port.apply(this, arguments);
}
function get_request_log(_x89) {
  return _get_request_log.apply(this, arguments);
}
function _get_request_log() {
  _get_request_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee88(params) {
    return _regeneratorRuntime().wrap(function _callee88$(_context88) {
      while (1) switch (_context88.prev = _context88.next) {
        case 0:
          return _context88.abrupt("return", $.getJSON("/v1/company/get_request_log/", params));
        case 1:
        case "end":
          return _context88.stop();
      }
    }, _callee88);
  }));
  return _get_request_log.apply(this, arguments);
}
function get_bandwidth_stat_all(_x90) {
  return _get_bandwidth_stat_all.apply(this, arguments);
}
function _get_bandwidth_stat_all() {
  _get_bandwidth_stat_all = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee89(params) {
    return _regeneratorRuntime().wrap(function _callee89$(_context89) {
      while (1) switch (_context89.prev = _context89.next) {
        case 0:
          return _context89.abrupt("return", $.getJSON("/v1/company/get_bandwidth_stat_all/", params));
        case 1:
        case "end":
          return _context89.stop();
      }
    }, _callee89);
  }));
  return _get_bandwidth_stat_all.apply(this, arguments);
}
function get_device_type_stat(_x91) {
  return _get_device_type_stat.apply(this, arguments);
}
function _get_device_type_stat() {
  _get_device_type_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee90(params) {
    return _regeneratorRuntime().wrap(function _callee90$(_context90) {
      while (1) switch (_context90.prev = _context90.next) {
        case 0:
          return _context90.abrupt("return", $.getJSON("/v1/company/get_device_type_stat/", params));
        case 1:
        case "end":
          return _context90.stop();
      }
    }, _callee90);
  }));
  return _get_device_type_stat.apply(this, arguments);
}
function get_device_model_stat(_x92) {
  return _get_device_model_stat.apply(this, arguments);
}
function _get_device_model_stat() {
  _get_device_model_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee91(params) {
    return _regeneratorRuntime().wrap(function _callee91$(_context91) {
      while (1) switch (_context91.prev = _context91.next) {
        case 0:
          return _context91.abrupt("return", $.getJSON("/v1/company/get_device_model_stat/", params));
        case 1:
        case "end":
          return _context91.stop();
      }
    }, _callee91);
  }));
  return _get_device_model_stat.apply(this, arguments);
}
function get_redis_alarm(_x93) {
  return _get_redis_alarm.apply(this, arguments);
}
function _get_redis_alarm() {
  _get_redis_alarm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee92(params) {
    return _regeneratorRuntime().wrap(function _callee92$(_context92) {
      while (1) switch (_context92.prev = _context92.next) {
        case 0:
          return _context92.abrupt("return", $.getJSON("/v1/company/get_redis_alarm/", params));
        case 1:
        case "end":
          return _context92.stop();
      }
    }, _callee92);
  }));
  return _get_redis_alarm.apply(this, arguments);
}
function batch_update_redis_alarm(_x94) {
  return _batch_update_redis_alarm.apply(this, arguments);
}
function _batch_update_redis_alarm() {
  _batch_update_redis_alarm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee93(params) {
    return _regeneratorRuntime().wrap(function _callee93$(_context93) {
      while (1) switch (_context93.prev = _context93.next) {
        case 0:
          return _context93.abrupt("return", $.post("/v1/company/batch_update_redis_alarm/", params));
        case 1:
        case "end":
          return _context93.stop();
      }
    }, _callee93);
  }));
  return _batch_update_redis_alarm.apply(this, arguments);
}
function move_device(_x95) {
  return _move_device.apply(this, arguments);
}
function _move_device() {
  _move_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee94(params) {
    return _regeneratorRuntime().wrap(function _callee94$(_context94) {
      while (1) switch (_context94.prev = _context94.next) {
        case 0:
          return _context94.abrupt("return", $.post("/v1/company/move_device/", params));
        case 1:
        case "end":
          return _context94.stop();
      }
    }, _callee94);
  }));
  return _move_device.apply(this, arguments);
}
function get_redis_alarm_stat(_x96) {
  return _get_redis_alarm_stat.apply(this, arguments);
}
function _get_redis_alarm_stat() {
  _get_redis_alarm_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee95(params) {
    return _regeneratorRuntime().wrap(function _callee95$(_context95) {
      while (1) switch (_context95.prev = _context95.next) {
        case 0:
          return _context95.abrupt("return", $.getJSON("/v1/company/get_redis_alarm_stat/", params));
        case 1:
        case "end":
          return _context95.stop();
      }
    }, _callee95);
  }));
  return _get_redis_alarm_stat.apply(this, arguments);
}
function get_redis_alarm_log(_x97) {
  return _get_redis_alarm_log.apply(this, arguments);
}
function _get_redis_alarm_log() {
  _get_redis_alarm_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee96(params) {
    return _regeneratorRuntime().wrap(function _callee96$(_context96) {
      while (1) switch (_context96.prev = _context96.next) {
        case 0:
          return _context96.abrupt("return", $.getJSON("/v1/company/get_redis_alarm_log/", params));
        case 1:
        case "end":
          return _context96.stop();
      }
    }, _callee96);
  }));
  return _get_redis_alarm_log.apply(this, arguments);
}
function deal_alarm(_x98) {
  return _deal_alarm.apply(this, arguments);
}
function _deal_alarm() {
  _deal_alarm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee97(params) {
    return _regeneratorRuntime().wrap(function _callee97$(_context97) {
      while (1) switch (_context97.prev = _context97.next) {
        case 0:
          return _context97.abrupt("return", $.post("/v1/company/deal_alarm/", params));
        case 1:
        case "end":
          return _context97.stop();
      }
    }, _callee97);
  }));
  return _deal_alarm.apply(this, arguments);
}
function exchange_device(_x99) {
  return _exchange_device.apply(this, arguments);
}
function _exchange_device() {
  _exchange_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee98(params) {
    return _regeneratorRuntime().wrap(function _callee98$(_context98) {
      while (1) switch (_context98.prev = _context98.next) {
        case 0:
          return _context98.abrupt("return", $.post("/v1/company/exchange_device/", params, false, "设备更换中", true));
        case 1:
        case "end":
          return _context98.stop();
      }
    }, _callee98);
  }));
  return _exchange_device.apply(this, arguments);
}
function get_address(_x100) {
  return _get_address.apply(this, arguments);
}
function _get_address() {
  _get_address = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee99(params) {
    return _regeneratorRuntime().wrap(function _callee99$(_context99) {
      while (1) switch (_context99.prev = _context99.next) {
        case 0:
          return _context99.abrupt("return", $.getJSON("/v1/company/get_address/", params));
        case 1:
        case "end":
          return _context99.stop();
      }
    }, _callee99);
  }));
  return _get_address.apply(this, arguments);
}
function get_area(_x101) {
  return _get_area.apply(this, arguments);
}
function _get_area() {
  _get_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee100(params) {
    return _regeneratorRuntime().wrap(function _callee100$(_context100) {
      while (1) switch (_context100.prev = _context100.next) {
        case 0:
          return _context100.abrupt("return", $.getJSON("/v1/company/get_area/", params));
        case 1:
        case "end":
          return _context100.stop();
      }
    }, _callee100);
  }));
  return _get_area.apply(this, arguments);
}
function create_area(_x102) {
  return _create_area.apply(this, arguments);
}
function _create_area() {
  _create_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee101(params) {
    return _regeneratorRuntime().wrap(function _callee101$(_context101) {
      while (1) switch (_context101.prev = _context101.next) {
        case 0:
          return _context101.abrupt("return", $.post("/v1/company/create_area/", params));
        case 1:
        case "end":
          return _context101.stop();
      }
    }, _callee101);
  }));
  return _create_area.apply(this, arguments);
}
function update_area(_x103) {
  return _update_area.apply(this, arguments);
}
function _update_area() {
  _update_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee102(params) {
    return _regeneratorRuntime().wrap(function _callee102$(_context102) {
      while (1) switch (_context102.prev = _context102.next) {
        case 0:
          return _context102.abrupt("return", $.post("/v1/company/update_area/", params));
        case 1:
        case "end":
          return _context102.stop();
      }
    }, _callee102);
  }));
  return _update_area.apply(this, arguments);
}
function delete_area(_x104) {
  return _delete_area.apply(this, arguments);
}
function _delete_area() {
  _delete_area = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee103(params) {
    return _regeneratorRuntime().wrap(function _callee103$(_context103) {
      while (1) switch (_context103.prev = _context103.next) {
        case 0:
          return _context103.abrupt("return", $.post("/v1/company/delete_area/", params));
        case 1:
        case "end":
          return _context103.stop();
      }
    }, _callee103);
  }));
  return _delete_area.apply(this, arguments);
}
function create_address(_x105) {
  return _create_address.apply(this, arguments);
}
function _create_address() {
  _create_address = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee104(params) {
    return _regeneratorRuntime().wrap(function _callee104$(_context104) {
      while (1) switch (_context104.prev = _context104.next) {
        case 0:
          return _context104.abrupt("return", $.post("/v1/company/create_address/", params));
        case 1:
        case "end":
          return _context104.stop();
      }
    }, _callee104);
  }));
  return _create_address.apply(this, arguments);
}
function update_address(_x106) {
  return _update_address.apply(this, arguments);
}
function _update_address() {
  _update_address = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee105(params) {
    return _regeneratorRuntime().wrap(function _callee105$(_context105) {
      while (1) switch (_context105.prev = _context105.next) {
        case 0:
          return _context105.abrupt("return", $.post("/v1/company/update_address/", params));
        case 1:
        case "end":
          return _context105.stop();
      }
    }, _callee105);
  }));
  return _update_address.apply(this, arguments);
}
function delete_address(_x107) {
  return _delete_address.apply(this, arguments);
}
function _delete_address() {
  _delete_address = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee106(params) {
    return _regeneratorRuntime().wrap(function _callee106$(_context106) {
      while (1) switch (_context106.prev = _context106.next) {
        case 0:
          return _context106.abrupt("return", $.post("/v1/company/delete_address/", params));
        case 1:
        case "end":
          return _context106.stop();
      }
    }, _callee106);
  }));
  return _delete_address.apply(this, arguments);
}
function get_device_model(_x108) {
  return _get_device_model.apply(this, arguments);
}
function _get_device_model() {
  _get_device_model = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee107(params) {
    return _regeneratorRuntime().wrap(function _callee107$(_context107) {
      while (1) switch (_context107.prev = _context107.next) {
        case 0:
          return _context107.abrupt("return", $.getJSON("/v1/company/get_device_model/", params));
        case 1:
        case "end":
          return _context107.stop();
      }
    }, _callee107);
  }));
  return _get_device_model.apply(this, arguments);
}
function create_device_model(_x109) {
  return _create_device_model.apply(this, arguments);
}
function _create_device_model() {
  _create_device_model = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee108(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee108$(_context108) {
      while (1) switch (_context108.prev = _context108.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            if (key === 'file' && params[key]) {
              formData.append(key, params[key][0] || "");
            } else {
              formData.append(key, params[key] === undefined ? "" : params[key]);
            }
          }
          return _context108.abrupt("return", $.formPost("/v1/company/create_device_model/", formData));
        case 3:
        case "end":
          return _context108.stop();
      }
    }, _callee108);
  }));
  return _create_device_model.apply(this, arguments);
}
function update_device_model(_x110) {
  return _update_device_model.apply(this, arguments);
}
function _update_device_model() {
  _update_device_model = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee109(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee109$(_context109) {
      while (1) switch (_context109.prev = _context109.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            if (key === 'file' && params[key]) {
              formData.append(key, params[key][0]);
            } else {
              formData.append(key, params[key] === undefined ? "" : params[key]);
            }
          }
          return _context109.abrupt("return", $.formPost("/v1/company/update_device_model/", formData));
        case 3:
        case "end":
          return _context109.stop();
      }
    }, _callee109);
  }));
  return _update_device_model.apply(this, arguments);
}
function delete_device_model(_x111) {
  return _delete_device_model.apply(this, arguments);
}
function _delete_device_model() {
  _delete_device_model = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee110(params) {
    return _regeneratorRuntime().wrap(function _callee110$(_context110) {
      while (1) switch (_context110.prev = _context110.next) {
        case 0:
          return _context110.abrupt("return", $.post("/v1/company/delete_device_model/", params));
        case 1:
        case "end":
          return _context110.stop();
      }
    }, _callee110);
  }));
  return _delete_device_model.apply(this, arguments);
}
function get_update_task_list(_x112) {
  return _get_update_task_list.apply(this, arguments);
}
function _get_update_task_list() {
  _get_update_task_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee111(params) {
    return _regeneratorRuntime().wrap(function _callee111$(_context111) {
      while (1) switch (_context111.prev = _context111.next) {
        case 0:
          return _context111.abrupt("return", $.getJSON("/v1/task/get_update_task_list/", params));
        case 1:
        case "end":
          return _context111.stop();
      }
    }, _callee111);
  }));
  return _get_update_task_list.apply(this, arguments);
}
function update_link_batch(_x113) {
  return _update_link_batch.apply(this, arguments);
}
function _update_link_batch() {
  _update_link_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee112(params) {
    return _regeneratorRuntime().wrap(function _callee112$(_context112) {
      while (1) switch (_context112.prev = _context112.next) {
        case 0:
          return _context112.abrupt("return", $.post("/v1/company/update_link_batch/", params));
        case 1:
        case "end":
          return _context112.stop();
      }
    }, _callee112);
  }));
  return _update_link_batch.apply(this, arguments);
}
function get_script_list(_x114) {
  return _get_script_list.apply(this, arguments);
}
function _get_script_list() {
  _get_script_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee113(params) {
    return _regeneratorRuntime().wrap(function _callee113$(_context113) {
      while (1) switch (_context113.prev = _context113.next) {
        case 0:
          return _context113.abrupt("return", $.getJSON("/v1/company/get_script_list/", params));
        case 1:
        case "end":
          return _context113.stop();
      }
    }, _callee113);
  }));
  return _get_script_list.apply(this, arguments);
}
function send_command(_x115) {
  return _send_command.apply(this, arguments);
}
function _send_command() {
  _send_command = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee114(params) {
    return _regeneratorRuntime().wrap(function _callee114$(_context114) {
      while (1) switch (_context114.prev = _context114.next) {
        case 0:
          return _context114.abrupt("return", $.post("/v1/company/send_command/", params));
        case 1:
        case "end":
          return _context114.stop();
      }
    }, _callee114);
  }));
  return _send_command.apply(this, arguments);
}
function delete_empty_link(_x116) {
  return _delete_empty_link.apply(this, arguments);
}
function _delete_empty_link() {
  _delete_empty_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee115(params) {
    return _regeneratorRuntime().wrap(function _callee115$(_context115) {
      while (1) switch (_context115.prev = _context115.next) {
        case 0:
          return _context115.abrupt("return", $.post("/v1/company/delete_empty_link/", params));
        case 1:
        case "end":
          return _context115.stop();
      }
    }, _callee115);
  }));
  return _delete_empty_link.apply(this, arguments);
}
function get_device_version_list(_x117) {
  return _get_device_version_list.apply(this, arguments);
}
function _get_device_version_list() {
  _get_device_version_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee116(params) {
    return _regeneratorRuntime().wrap(function _callee116$(_context116) {
      while (1) switch (_context116.prev = _context116.next) {
        case 0:
          return _context116.abrupt("return", $.getJSON("/v1/company/get_device_version_list/", params));
        case 1:
        case "end":
          return _context116.stop();
      }
    }, _callee116);
  }));
  return _get_device_version_list.apply(this, arguments);
}
function get_manual_link_path_placeholder(_x118) {
  return _get_manual_link_path_placeholder.apply(this, arguments);
}
function _get_manual_link_path_placeholder() {
  _get_manual_link_path_placeholder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee117(params) {
    return _regeneratorRuntime().wrap(function _callee117$(_context117) {
      while (1) switch (_context117.prev = _context117.next) {
        case 0:
          return _context117.abrupt("return", $.getJSON("/v1/company/get_manual_link_path_placeholder/", params));
        case 1:
        case "end":
          return _context117.stop();
      }
    }, _callee117);
  }));
  return _get_manual_link_path_placeholder.apply(this, arguments);
}
function get_logo(_x119) {
  return _get_logo.apply(this, arguments);
}
function _get_logo() {
  _get_logo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee118(params) {
    return _regeneratorRuntime().wrap(function _callee118$(_context118) {
      while (1) switch (_context118.prev = _context118.next) {
        case 0:
          return _context118.abrupt("return", $.getJSON("/v1/company/get_logo/", params));
        case 1:
        case "end":
          return _context118.stop();
      }
    }, _callee118);
  }));
  return _get_logo.apply(this, arguments);
}
function out_stock_batch(_x120) {
  return _out_stock_batch.apply(this, arguments);
}
function _out_stock_batch() {
  _out_stock_batch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee119(params) {
    return _regeneratorRuntime().wrap(function _callee119$(_context119) {
      while (1) switch (_context119.prev = _context119.next) {
        case 0:
          return _context119.abrupt("return", $.post("/v1/company/out_stock_batch/", params));
        case 1:
        case "end":
          return _context119.stop();
      }
    }, _callee119);
  }));
  return _out_stock_batch.apply(this, arguments);
}
function set_backup_link(_x121) {
  return _set_backup_link.apply(this, arguments);
}
function _set_backup_link() {
  _set_backup_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee120(params) {
    return _regeneratorRuntime().wrap(function _callee120$(_context120) {
      while (1) switch (_context120.prev = _context120.next) {
        case 0:
          return _context120.abrupt("return", $.post("/v1/company/set_backup_link/", params));
        case 1:
        case "end":
          return _context120.stop();
      }
    }, _callee120);
  }));
  return _set_backup_link.apply(this, arguments);
}
function get_wifi_config_file(_x122) {
  return _get_wifi_config_file.apply(this, arguments);
}
function _get_wifi_config_file() {
  _get_wifi_config_file = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee121(params) {
    return _regeneratorRuntime().wrap(function _callee121$(_context121) {
      while (1) switch (_context121.prev = _context121.next) {
        case 0:
          return _context121.abrupt("return", $.getJSON("/v1/company/get_wifi_config_file/", params));
        case 1:
        case "end":
          return _context121.stop();
      }
    }, _callee121);
  }));
  return _get_wifi_config_file.apply(this, arguments);
}
function get_wifi(_x123) {
  return _get_wifi.apply(this, arguments);
}
function _get_wifi() {
  _get_wifi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee122(params) {
    return _regeneratorRuntime().wrap(function _callee122$(_context122) {
      while (1) switch (_context122.prev = _context122.next) {
        case 0:
          return _context122.abrupt("return", $.getJSON("/v1/company/get_wifi/", params));
        case 1:
        case "end":
          return _context122.stop();
      }
    }, _callee122);
  }));
  return _get_wifi.apply(this, arguments);
}
function create_client_auth(_x124) {
  return _create_client_auth.apply(this, arguments);
}
function _create_client_auth() {
  _create_client_auth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee123(params) {
    return _regeneratorRuntime().wrap(function _callee123$(_context123) {
      while (1) switch (_context123.prev = _context123.next) {
        case 0:
          return _context123.abrupt("return", $.post("/v1/company/create_client_auth/", params));
        case 1:
        case "end":
          return _context123.stop();
      }
    }, _callee123);
  }));
  return _create_client_auth.apply(this, arguments);
}
function update_client_auth(_x125) {
  return _update_client_auth.apply(this, arguments);
}
function _update_client_auth() {
  _update_client_auth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee124(params) {
    return _regeneratorRuntime().wrap(function _callee124$(_context124) {
      while (1) switch (_context124.prev = _context124.next) {
        case 0:
          return _context124.abrupt("return", $.post("/v1/company/update_client_auth/", params));
        case 1:
        case "end":
          return _context124.stop();
      }
    }, _callee124);
  }));
  return _update_client_auth.apply(this, arguments);
}
function delete_client_auth(_x126) {
  return _delete_client_auth.apply(this, arguments);
}
function _delete_client_auth() {
  _delete_client_auth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee125(params) {
    return _regeneratorRuntime().wrap(function _callee125$(_context125) {
      while (1) switch (_context125.prev = _context125.next) {
        case 0:
          return _context125.abrupt("return", $.post("/v1/company/delete_client_auth/", params));
        case 1:
        case "end":
          return _context125.stop();
      }
    }, _callee125);
  }));
  return _delete_client_auth.apply(this, arguments);
}
function get_client_auth(_x127) {
  return _get_client_auth.apply(this, arguments);
}
function _get_client_auth() {
  _get_client_auth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee126(params) {
    return _regeneratorRuntime().wrap(function _callee126$(_context126) {
      while (1) switch (_context126.prev = _context126.next) {
        case 0:
          return _context126.abrupt("return", $.getJSON("/v1/company/get_client_auth/", params));
        case 1:
        case "end":
          return _context126.stop();
      }
    }, _callee126);
  }));
  return _get_client_auth.apply(this, arguments);
}
function get_lan_template(_x128) {
  return _get_lan_template.apply(this, arguments);
}
function _get_lan_template() {
  _get_lan_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee127(params) {
    return _regeneratorRuntime().wrap(function _callee127$(_context127) {
      while (1) switch (_context127.prev = _context127.next) {
        case 0:
          return _context127.abrupt("return", $.getJSON("/v1/company/get_lan_template/", params));
        case 1:
        case "end":
          return _context127.stop();
      }
    }, _callee127);
  }));
  return _get_lan_template.apply(this, arguments);
}
function create_cpe_template(_x129) {
  return _create_cpe_template.apply(this, arguments);
}
function _create_cpe_template() {
  _create_cpe_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee128(params) {
    return _regeneratorRuntime().wrap(function _callee128$(_context128) {
      while (1) switch (_context128.prev = _context128.next) {
        case 0:
          return _context128.abrupt("return", $.post("/v1/company/create_cpe_template/", params));
        case 1:
        case "end":
          return _context128.stop();
      }
    }, _callee128);
  }));
  return _create_cpe_template.apply(this, arguments);
}
function update_cpe_template(_x130) {
  return _update_cpe_template.apply(this, arguments);
}
function _update_cpe_template() {
  _update_cpe_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee129(params) {
    return _regeneratorRuntime().wrap(function _callee129$(_context129) {
      while (1) switch (_context129.prev = _context129.next) {
        case 0:
          return _context129.abrupt("return", $.post("/v1/company/update_cpe_template/", params));
        case 1:
        case "end":
          return _context129.stop();
      }
    }, _callee129);
  }));
  return _update_cpe_template.apply(this, arguments);
}
function delete_cpe_template(_x131) {
  return _delete_cpe_template.apply(this, arguments);
}
function _delete_cpe_template() {
  _delete_cpe_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee130(params) {
    return _regeneratorRuntime().wrap(function _callee130$(_context130) {
      while (1) switch (_context130.prev = _context130.next) {
        case 0:
          return _context130.abrupt("return", $.post("/v1/company/delete_cpe_template/", params));
        case 1:
        case "end":
          return _context130.stop();
      }
    }, _callee130);
  }));
  return _delete_cpe_template.apply(this, arguments);
}
function get_cpe_template(_x132) {
  return _get_cpe_template.apply(this, arguments);
}
function _get_cpe_template() {
  _get_cpe_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee131(params) {
    return _regeneratorRuntime().wrap(function _callee131$(_context131) {
      while (1) switch (_context131.prev = _context131.next) {
        case 0:
          return _context131.abrupt("return", $.getJSON("/v1/company/get_cpe_template/", params));
        case 1:
        case "end":
          return _context131.stop();
      }
    }, _callee131);
  }));
  return _get_cpe_template.apply(this, arguments);
}
function duplicate_cpe_template(_x133) {
  return _duplicate_cpe_template.apply(this, arguments);
}
function _duplicate_cpe_template() {
  _duplicate_cpe_template = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee132(params) {
    return _regeneratorRuntime().wrap(function _callee132$(_context132) {
      while (1) switch (_context132.prev = _context132.next) {
        case 0:
          return _context132.abrupt("return", $.post("/v1/company/duplicate_cpe_template/", params));
        case 1:
        case "end":
          return _context132.stop();
      }
    }, _callee132);
  }));
  return _duplicate_cpe_template.apply(this, arguments);
}
function get_cpe_template_agency(_x134) {
  return _get_cpe_template_agency.apply(this, arguments);
}
function _get_cpe_template_agency() {
  _get_cpe_template_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee133(params) {
    return _regeneratorRuntime().wrap(function _callee133$(_context133) {
      while (1) switch (_context133.prev = _context133.next) {
        case 0:
          return _context133.abrupt("return", $.getJSON("/v1/company/get_cpe_template_agency/", params));
        case 1:
        case "end":
          return _context133.stop();
      }
    }, _callee133);
  }));
  return _get_cpe_template_agency.apply(this, arguments);
}
function update_cpe_template_agency(_x135) {
  return _update_cpe_template_agency.apply(this, arguments);
}
function _update_cpe_template_agency() {
  _update_cpe_template_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee134(params) {
    return _regeneratorRuntime().wrap(function _callee134$(_context134) {
      while (1) switch (_context134.prev = _context134.next) {
        case 0:
          return _context134.abrupt("return", $.post("/v1/company/update_cpe_template_agency/", params));
        case 1:
        case "end":
          return _context134.stop();
      }
    }, _callee134);
  }));
  return _update_cpe_template_agency.apply(this, arguments);
}
function push_config(_x136) {
  return _push_config.apply(this, arguments);
}
function _push_config() {
  _push_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee135(params) {
    return _regeneratorRuntime().wrap(function _callee135$(_context135) {
      while (1) switch (_context135.prev = _context135.next) {
        case 0:
          return _context135.abrupt("return", $.post("/v1/company/push_config/", params));
        case 1:
        case "end":
          return _context135.stop();
      }
    }, _callee135);
  }));
  return _push_config.apply(this, arguments);
}
function update_app_version(_x137) {
  return _update_app_version.apply(this, arguments);
}
function _update_app_version() {
  _update_app_version = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee136(params) {
    return _regeneratorRuntime().wrap(function _callee136$(_context136) {
      while (1) switch (_context136.prev = _context136.next) {
        case 0:
          return _context136.abrupt("return", $.post("/v1/company/update_app_version/", params));
        case 1:
        case "end":
          return _context136.stop();
      }
    }, _callee136);
  }));
  return _update_app_version.apply(this, arguments);
}
function get_app_version(_x138) {
  return _get_app_version.apply(this, arguments);
}
function _get_app_version() {
  _get_app_version = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee137(params) {
    return _regeneratorRuntime().wrap(function _callee137$(_context137) {
      while (1) switch (_context137.prev = _context137.next) {
        case 0:
          return _context137.abrupt("return", $.getJSON("/v1/company/get_app_version/", params));
        case 1:
        case "end":
          return _context137.stop();
      }
    }, _callee137);
  }));
  return _get_app_version.apply(this, arguments);
}
function get_app_version_company(_x139) {
  return _get_app_version_company.apply(this, arguments);
}
function _get_app_version_company() {
  _get_app_version_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee138(params) {
    return _regeneratorRuntime().wrap(function _callee138$(_context138) {
      while (1) switch (_context138.prev = _context138.next) {
        case 0:
          return _context138.abrupt("return", $.getJSON("/v1/company/get_app_version_company/", params));
        case 1:
        case "end":
          return _context138.stop();
      }
    }, _callee138);
  }));
  return _get_app_version_company.apply(this, arguments);
}
function create_app_version_company(_x140) {
  return _create_app_version_company.apply(this, arguments);
}
function _create_app_version_company() {
  _create_app_version_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee139(params) {
    return _regeneratorRuntime().wrap(function _callee139$(_context139) {
      while (1) switch (_context139.prev = _context139.next) {
        case 0:
          return _context139.abrupt("return", $.post("/v1/company/create_app_version_company/", params));
        case 1:
        case "end":
          return _context139.stop();
      }
    }, _callee139);
  }));
  return _create_app_version_company.apply(this, arguments);
}
function update_app_version_company(_x141) {
  return _update_app_version_company.apply(this, arguments);
}
function _update_app_version_company() {
  _update_app_version_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee140(params) {
    return _regeneratorRuntime().wrap(function _callee140$(_context140) {
      while (1) switch (_context140.prev = _context140.next) {
        case 0:
          return _context140.abrupt("return", $.post("/v1/company/update_app_version_company/", params));
        case 1:
        case "end":
          return _context140.stop();
      }
    }, _callee140);
  }));
  return _update_app_version_company.apply(this, arguments);
}
function delete_app_version_company(_x142) {
  return _delete_app_version_company.apply(this, arguments);
}
function _delete_app_version_company() {
  _delete_app_version_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee141(params) {
    return _regeneratorRuntime().wrap(function _callee141$(_context141) {
      while (1) switch (_context141.prev = _context141.next) {
        case 0:
          return _context141.abrupt("return", $.post("/v1/company/delete_app_version_company/", params));
        case 1:
        case "end":
          return _context141.stop();
      }
    }, _callee141);
  }));
  return _delete_app_version_company.apply(this, arguments);
}
function create_app_ipset(_x143) {
  return _create_app_ipset.apply(this, arguments);
}
function _create_app_ipset() {
  _create_app_ipset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee142(params) {
    return _regeneratorRuntime().wrap(function _callee142$(_context142) {
      while (1) switch (_context142.prev = _context142.next) {
        case 0:
          return _context142.abrupt("return", $.post("/v1/company/create_app_ipset/", params));
        case 1:
        case "end":
          return _context142.stop();
      }
    }, _callee142);
  }));
  return _create_app_ipset.apply(this, arguments);
}
function update_app_ipset(_x144) {
  return _update_app_ipset.apply(this, arguments);
}
function _update_app_ipset() {
  _update_app_ipset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee143(params) {
    return _regeneratorRuntime().wrap(function _callee143$(_context143) {
      while (1) switch (_context143.prev = _context143.next) {
        case 0:
          return _context143.abrupt("return", $.post("/v1/company/update_app_ipset/", params));
        case 1:
        case "end":
          return _context143.stop();
      }
    }, _callee143);
  }));
  return _update_app_ipset.apply(this, arguments);
}
function delete_app_ipset(_x145) {
  return _delete_app_ipset.apply(this, arguments);
}
function _delete_app_ipset() {
  _delete_app_ipset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee144(params) {
    return _regeneratorRuntime().wrap(function _callee144$(_context144) {
      while (1) switch (_context144.prev = _context144.next) {
        case 0:
          return _context144.abrupt("return", $.post("/v1/company/delete_app_ipset/", params));
        case 1:
        case "end":
          return _context144.stop();
      }
    }, _callee144);
  }));
  return _delete_app_ipset.apply(this, arguments);
}
function get_app_ipset(_x146) {
  return _get_app_ipset.apply(this, arguments);
}
function _get_app_ipset() {
  _get_app_ipset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee145(params) {
    return _regeneratorRuntime().wrap(function _callee145$(_context145) {
      while (1) switch (_context145.prev = _context145.next) {
        case 0:
          return _context145.abrupt("return", $.getJSON("/v1/company/get_app_ipset/", params));
        case 1:
        case "end":
          return _context145.stop();
      }
    }, _callee145);
  }));
  return _get_app_ipset.apply(this, arguments);
}
function get_app_account(_x147) {
  return _get_app_account.apply(this, arguments);
}
function _get_app_account() {
  _get_app_account = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee146(params) {
    return _regeneratorRuntime().wrap(function _callee146$(_context146) {
      while (1) switch (_context146.prev = _context146.next) {
        case 0:
          return _context146.abrupt("return", $.getJSON("/v1/company/get_app_account_new/", params));
        case 1:
        case "end":
          return _context146.stop();
      }
    }, _callee146);
  }));
  return _get_app_account.apply(this, arguments);
}
function create_app_account(_x148) {
  return _create_app_account.apply(this, arguments);
}
function _create_app_account() {
  _create_app_account = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee147(params) {
    return _regeneratorRuntime().wrap(function _callee147$(_context147) {
      while (1) switch (_context147.prev = _context147.next) {
        case 0:
          return _context147.abrupt("return", $.post("/v1/company/create_app_account_new/", params));
        case 1:
        case "end":
          return _context147.stop();
      }
    }, _callee147);
  }));
  return _create_app_account.apply(this, arguments);
}
function update_app_account(_x149) {
  return _update_app_account.apply(this, arguments);
}
function _update_app_account() {
  _update_app_account = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee148(params) {
    return _regeneratorRuntime().wrap(function _callee148$(_context148) {
      while (1) switch (_context148.prev = _context148.next) {
        case 0:
          return _context148.abrupt("return", $.post("/v1/company/update_app_account_new/", params));
        case 1:
        case "end":
          return _context148.stop();
      }
    }, _callee148);
  }));
  return _update_app_account.apply(this, arguments);
}
function delete_app_account(_x150) {
  return _delete_app_account.apply(this, arguments);
}
function _delete_app_account() {
  _delete_app_account = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee149(params) {
    return _regeneratorRuntime().wrap(function _callee149$(_context149) {
      while (1) switch (_context149.prev = _context149.next) {
        case 0:
          return _context149.abrupt("return", $.post("/v1/company/delete_app_account/", params));
        case 1:
        case "end":
          return _context149.stop();
      }
    }, _callee149);
  }));
  return _delete_app_account.apply(this, arguments);
}
function get_agency_group(_x151) {
  return _get_agency_group.apply(this, arguments);
}
function _get_agency_group() {
  _get_agency_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee150(params) {
    return _regeneratorRuntime().wrap(function _callee150$(_context150) {
      while (1) switch (_context150.prev = _context150.next) {
        case 0:
          return _context150.abrupt("return", $.getJSON("/v1/company/get_agency_group/", params));
        case 1:
        case "end":
          return _context150.stop();
      }
    }, _callee150);
  }));
  return _get_agency_group.apply(this, arguments);
}
function create_agency_group(_x152) {
  return _create_agency_group.apply(this, arguments);
}
function _create_agency_group() {
  _create_agency_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee151(params) {
    return _regeneratorRuntime().wrap(function _callee151$(_context151) {
      while (1) switch (_context151.prev = _context151.next) {
        case 0:
          return _context151.abrupt("return", $.post("/v1/company/create_agency_group/", params));
        case 1:
        case "end":
          return _context151.stop();
      }
    }, _callee151);
  }));
  return _create_agency_group.apply(this, arguments);
}
function update_agency_group(_x153) {
  return _update_agency_group.apply(this, arguments);
}
function _update_agency_group() {
  _update_agency_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee152(params) {
    return _regeneratorRuntime().wrap(function _callee152$(_context152) {
      while (1) switch (_context152.prev = _context152.next) {
        case 0:
          return _context152.abrupt("return", $.post("/v1/company/update_agency_group/", params));
        case 1:
        case "end":
          return _context152.stop();
      }
    }, _callee152);
  }));
  return _update_agency_group.apply(this, arguments);
}
function delete_agency_group(_x154) {
  return _delete_agency_group.apply(this, arguments);
}
function _delete_agency_group() {
  _delete_agency_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee153(params) {
    return _regeneratorRuntime().wrap(function _callee153$(_context153) {
      while (1) switch (_context153.prev = _context153.next) {
        case 0:
          return _context153.abrupt("return", $.post("/v1/company/delete_agency_group/", params));
        case 1:
        case "end":
          return _context153.stop();
      }
    }, _callee153);
  }));
  return _delete_agency_group.apply(this, arguments);
}
function get_app_device(_x155) {
  return _get_app_device.apply(this, arguments);
}
function _get_app_device() {
  _get_app_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee154(params) {
    return _regeneratorRuntime().wrap(function _callee154$(_context154) {
      while (1) switch (_context154.prev = _context154.next) {
        case 0:
          return _context154.abrupt("return", $.getJSON("/v1/company/get_app_device/", params));
        case 1:
        case "end":
          return _context154.stop();
      }
    }, _callee154);
  }));
  return _get_app_device.apply(this, arguments);
}
function get_dpi_apps_category(_x156) {
  return _get_dpi_apps_category.apply(this, arguments);
}
function _get_dpi_apps_category() {
  _get_dpi_apps_category = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee155(params) {
    return _regeneratorRuntime().wrap(function _callee155$(_context155) {
      while (1) switch (_context155.prev = _context155.next) {
        case 0:
          return _context155.abrupt("return", $.getJSON("/v1/company/get_dpi_apps_category/", params));
        case 1:
        case "end":
          return _context155.stop();
      }
    }, _callee155);
  }));
  return _get_dpi_apps_category.apply(this, arguments);
}
function update_dpi_apps_category(_x157) {
  return _update_dpi_apps_category.apply(this, arguments);
}
function _update_dpi_apps_category() {
  _update_dpi_apps_category = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee156(params) {
    return _regeneratorRuntime().wrap(function _callee156$(_context156) {
      while (1) switch (_context156.prev = _context156.next) {
        case 0:
          return _context156.abrupt("return", $.post("/v1/company/update_dpi_apps_category/", params));
        case 1:
        case "end":
          return _context156.stop();
      }
    }, _callee156);
  }));
  return _update_dpi_apps_category.apply(this, arguments);
}
function delete_dpi_apps(_x158) {
  return _delete_dpi_apps.apply(this, arguments);
}
function _delete_dpi_apps() {
  _delete_dpi_apps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee157(params) {
    return _regeneratorRuntime().wrap(function _callee157$(_context157) {
      while (1) switch (_context157.prev = _context157.next) {
        case 0:
          return _context157.abrupt("return", $.post("/v1/company/delete_dpi_apps/", params));
        case 1:
        case "end":
          return _context157.stop();
      }
    }, _callee157);
  }));
  return _delete_dpi_apps.apply(this, arguments);
}
function update_dpi_apps(_x159) {
  return _update_dpi_apps.apply(this, arguments);
}
function _update_dpi_apps() {
  _update_dpi_apps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee158(params) {
    return _regeneratorRuntime().wrap(function _callee158$(_context158) {
      while (1) switch (_context158.prev = _context158.next) {
        case 0:
          return _context158.abrupt("return", $.post("/v1/company/update_dpi_apps/", params));
        case 1:
        case "end":
          return _context158.stop();
      }
    }, _callee158);
  }));
  return _update_dpi_apps.apply(this, arguments);
}
function create_dpi_apps(_x160) {
  return _create_dpi_apps.apply(this, arguments);
}
function _create_dpi_apps() {
  _create_dpi_apps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee159(params) {
    return _regeneratorRuntime().wrap(function _callee159$(_context159) {
      while (1) switch (_context159.prev = _context159.next) {
        case 0:
          return _context159.abrupt("return", $.post("/v1/company/create_dpi_apps/", params));
        case 1:
        case "end":
          return _context159.stop();
      }
    }, _callee159);
  }));
  return _create_dpi_apps.apply(this, arguments);
}
function create_dpi_apps_category(_x161) {
  return _create_dpi_apps_category.apply(this, arguments);
}
function _create_dpi_apps_category() {
  _create_dpi_apps_category = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee160(params) {
    return _regeneratorRuntime().wrap(function _callee160$(_context160) {
      while (1) switch (_context160.prev = _context160.next) {
        case 0:
          return _context160.abrupt("return", $.post("/v1/company/create_dpi_apps_category/", params));
        case 1:
        case "end":
          return _context160.stop();
      }
    }, _callee160);
  }));
  return _create_dpi_apps_category.apply(this, arguments);
}
function delete_dpi_apps_category(_x162) {
  return _delete_dpi_apps_category.apply(this, arguments);
}
function _delete_dpi_apps_category() {
  _delete_dpi_apps_category = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee161(params) {
    return _regeneratorRuntime().wrap(function _callee161$(_context161) {
      while (1) switch (_context161.prev = _context161.next) {
        case 0:
          return _context161.abrupt("return", $.post("/v1/company/delete_dpi_apps_category/", params));
        case 1:
        case "end":
          return _context161.stop();
      }
    }, _callee161);
  }));
  return _delete_dpi_apps_category.apply(this, arguments);
}
function get_company_log(_x163) {
  return _get_company_log.apply(this, arguments);
}
function _get_company_log() {
  _get_company_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee162(params) {
    return _regeneratorRuntime().wrap(function _callee162$(_context162) {
      while (1) switch (_context162.prev = _context162.next) {
        case 0:
          return _context162.abrupt("return", $.getJSON("/v1/rate/get_company_log/", params));
        case 1:
        case "end":
          return _context162.stop();
      }
    }, _callee162);
  }));
  return _get_company_log.apply(this, arguments);
}
function get_ip_groups(_x164) {
  return _get_ip_groups.apply(this, arguments);
}
function _get_ip_groups() {
  _get_ip_groups = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee163(params) {
    return _regeneratorRuntime().wrap(function _callee163$(_context163) {
      while (1) switch (_context163.prev = _context163.next) {
        case 0:
          return _context163.abrupt("return", $.post("/v1/company/get_ip_groups/", params));
        case 1:
        case "end":
          return _context163.stop();
      }
    }, _callee163);
  }));
  return _get_ip_groups.apply(this, arguments);
}
function get_domain_group(_x165) {
  return _get_domain_group.apply(this, arguments);
}
function _get_domain_group() {
  _get_domain_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee164(params) {
    return _regeneratorRuntime().wrap(function _callee164$(_context164) {
      while (1) switch (_context164.prev = _context164.next) {
        case 0:
          return _context164.abrupt("return", $.getJSON("/v1/company/get_domain_group/", params));
        case 1:
        case "end":
          return _context164.stop();
      }
    }, _callee164);
  }));
  return _get_domain_group.apply(this, arguments);
}
function get_domain_list(_x166) {
  return _get_domain_list.apply(this, arguments);
}
function _get_domain_list() {
  _get_domain_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee165(params) {
    return _regeneratorRuntime().wrap(function _callee165$(_context165) {
      while (1) switch (_context165.prev = _context165.next) {
        case 0:
          return _context165.abrupt("return", $.getJSON("/v1/company/get_domain_list/", params));
        case 1:
        case "end":
          return _context165.stop();
      }
    }, _callee165);
  }));
  return _get_domain_list.apply(this, arguments);
}
function delete_domain_list(_x167) {
  return _delete_domain_list.apply(this, arguments);
}
function _delete_domain_list() {
  _delete_domain_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee166(params) {
    return _regeneratorRuntime().wrap(function _callee166$(_context166) {
      while (1) switch (_context166.prev = _context166.next) {
        case 0:
          return _context166.abrupt("return", $.post("/v1/company/delete_domain_list/", params));
        case 1:
        case "end":
          return _context166.stop();
      }
    }, _callee166);
  }));
  return _delete_domain_list.apply(this, arguments);
}
function create_domain_list(_x168) {
  return _create_domain_list.apply(this, arguments);
}
function _create_domain_list() {
  _create_domain_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee167(params) {
    return _regeneratorRuntime().wrap(function _callee167$(_context167) {
      while (1) switch (_context167.prev = _context167.next) {
        case 0:
          return _context167.abrupt("return", $.post("/v1/company/create_domain_list/", params));
        case 1:
        case "end":
          return _context167.stop();
      }
    }, _callee167);
  }));
  return _create_domain_list.apply(this, arguments);
}
function create_domain_group(_x169) {
  return _create_domain_group.apply(this, arguments);
}
function _create_domain_group() {
  _create_domain_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee168(params) {
    return _regeneratorRuntime().wrap(function _callee168$(_context168) {
      while (1) switch (_context168.prev = _context168.next) {
        case 0:
          return _context168.abrupt("return", $.post("/v1/company/create_domain_group/", params));
        case 1:
        case "end":
          return _context168.stop();
      }
    }, _callee168);
  }));
  return _create_domain_group.apply(this, arguments);
}
function update_domain_group(_x170) {
  return _update_domain_group.apply(this, arguments);
}
function _update_domain_group() {
  _update_domain_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee169(params) {
    return _regeneratorRuntime().wrap(function _callee169$(_context169) {
      while (1) switch (_context169.prev = _context169.next) {
        case 0:
          return _context169.abrupt("return", $.post("/v1/company/update_domain_group/", params));
        case 1:
        case "end":
          return _context169.stop();
      }
    }, _callee169);
  }));
  return _update_domain_group.apply(this, arguments);
}
function delete_domain_group(_x171) {
  return _delete_domain_group.apply(this, arguments);
}
function _delete_domain_group() {
  _delete_domain_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee170(params) {
    return _regeneratorRuntime().wrap(function _callee170$(_context170) {
      while (1) switch (_context170.prev = _context170.next) {
        case 0:
          return _context170.abrupt("return", $.post("/v1/company/delete_domain_group/", params));
        case 1:
        case "end":
          return _context170.stop();
      }
    }, _callee170);
  }));
  return _delete_domain_group.apply(this, arguments);
}
function create_app_group(_x172) {
  return _create_app_group.apply(this, arguments);
}
function _create_app_group() {
  _create_app_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee171(params) {
    return _regeneratorRuntime().wrap(function _callee171$(_context171) {
      while (1) switch (_context171.prev = _context171.next) {
        case 0:
          return _context171.abrupt("return", $.post("/v1/company/create_app_group/", params));
        case 1:
        case "end":
          return _context171.stop();
      }
    }, _callee171);
  }));
  return _create_app_group.apply(this, arguments);
}
function update_app_group(_x173) {
  return _update_app_group.apply(this, arguments);
}
function _update_app_group() {
  _update_app_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee172(params) {
    return _regeneratorRuntime().wrap(function _callee172$(_context172) {
      while (1) switch (_context172.prev = _context172.next) {
        case 0:
          return _context172.abrupt("return", $.post("/v1/company/update_app_group/", params));
        case 1:
        case "end":
          return _context172.stop();
      }
    }, _callee172);
  }));
  return _update_app_group.apply(this, arguments);
}
function delete_app_group(_x174) {
  return _delete_app_group.apply(this, arguments);
}
function _delete_app_group() {
  _delete_app_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee173(params) {
    return _regeneratorRuntime().wrap(function _callee173$(_context173) {
      while (1) switch (_context173.prev = _context173.next) {
        case 0:
          return _context173.abrupt("return", $.post("/v1/company/delete_app_group/", params));
        case 1:
        case "end":
          return _context173.stop();
      }
    }, _callee173);
  }));
  return _delete_app_group.apply(this, arguments);
}
function add_app_for_group(_x175) {
  return _add_app_for_group.apply(this, arguments);
}
function _add_app_for_group() {
  _add_app_for_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee174(params) {
    return _regeneratorRuntime().wrap(function _callee174$(_context174) {
      while (1) switch (_context174.prev = _context174.next) {
        case 0:
          return _context174.abrupt("return", $.post("/v1/company/add_app_for_group/", params));
        case 1:
        case "end":
          return _context174.stop();
      }
    }, _callee174);
  }));
  return _add_app_for_group.apply(this, arguments);
}
function remove_app_from_group(_x176) {
  return _remove_app_from_group.apply(this, arguments);
}
function _remove_app_from_group() {
  _remove_app_from_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee175(params) {
    return _regeneratorRuntime().wrap(function _callee175$(_context175) {
      while (1) switch (_context175.prev = _context175.next) {
        case 0:
          return _context175.abrupt("return", $.post("/v1/company/remove_app_from_group/", params));
        case 1:
        case "end":
          return _context175.stop();
      }
    }, _callee175);
  }));
  return _remove_app_from_group.apply(this, arguments);
}
function get_app_of_group(_x177) {
  return _get_app_of_group.apply(this, arguments);
}
function _get_app_of_group() {
  _get_app_of_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee176(params) {
    return _regeneratorRuntime().wrap(function _callee176$(_context176) {
      while (1) switch (_context176.prev = _context176.next) {
        case 0:
          return _context176.abrupt("return", $.getJSON("/v1/company/get_app_of_group/", params));
        case 1:
        case "end":
          return _context176.stop();
      }
    }, _callee176);
  }));
  return _get_app_of_group.apply(this, arguments);
}
function get_app_group(_x178) {
  return _get_app_group.apply(this, arguments);
}
function _get_app_group() {
  _get_app_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee177(params) {
    return _regeneratorRuntime().wrap(function _callee177$(_context177) {
      while (1) switch (_context177.prev = _context177.next) {
        case 0:
          return _context177.abrupt("return", $.getJSON("/v1/company/get_app_group/", params));
        case 1:
        case "end":
          return _context177.stop();
      }
    }, _callee177);
  }));
  return _get_app_group.apply(this, arguments);
}
function get_manual_link_path(_x179) {
  return _get_manual_link_path.apply(this, arguments);
}
function _get_manual_link_path() {
  _get_manual_link_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee178(params) {
    return _regeneratorRuntime().wrap(function _callee178$(_context178) {
      while (1) switch (_context178.prev = _context178.next) {
        case 0:
          return _context178.abrupt("return", $.getJSON("/v1/company/get_manual_link_path/", params));
        case 1:
        case "end":
          return _context178.stop();
      }
    }, _callee178);
  }));
  return _get_manual_link_path.apply(this, arguments);
}
function download_company_log(_x180) {
  return _download_company_log.apply(this, arguments);
}
function _download_company_log() {
  _download_company_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee179(params) {
    return _regeneratorRuntime().wrap(function _callee179$(_context179) {
      while (1) switch (_context179.prev = _context179.next) {
        case 0:
          return _context179.abrupt("return", $.getJSON("/v1/company/download_company_log/", params));
        case 1:
        case "end":
          return _context179.stop();
      }
    }, _callee179);
  }));
  return _download_company_log.apply(this, arguments);
}
function batch_update_device(_x181) {
  return _batch_update_device.apply(this, arguments);
}
function _batch_update_device() {
  _batch_update_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee180(params) {
    return _regeneratorRuntime().wrap(function _callee180$(_context180) {
      while (1) switch (_context180.prev = _context180.next) {
        case 0:
          return _context180.abrupt("return", $.post("/v1/company/batch_update_device/", params));
        case 1:
        case "end":
          return _context180.stop();
      }
    }, _callee180);
  }));
  return _batch_update_device.apply(this, arguments);
}
function update_interface_detect(_x182) {
  return _update_interface_detect.apply(this, arguments);
}
function _update_interface_detect() {
  _update_interface_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee181(params) {
    return _regeneratorRuntime().wrap(function _callee181$(_context181) {
      while (1) switch (_context181.prev = _context181.next) {
        case 0:
          return _context181.abrupt("return", $.post("/v1/company/update_interface_detect/", params));
        case 1:
        case "end":
          return _context181.stop();
      }
    }, _callee181);
  }));
  return _update_interface_detect.apply(this, arguments);
}
function get_national_ip(_x183) {
  return _get_national_ip.apply(this, arguments);
}
function _get_national_ip() {
  _get_national_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee182(params) {
    return _regeneratorRuntime().wrap(function _callee182$(_context182) {
      while (1) switch (_context182.prev = _context182.next) {
        case 0:
          return _context182.abrupt("return", $.getJSON("/v1/company/get_national_ip/", params));
        case 1:
        case "end":
          return _context182.stop();
      }
    }, _callee182);
  }));
  return _get_national_ip.apply(this, arguments);
}
function get_bgp(_x184) {
  return _get_bgp.apply(this, arguments);
}
function _get_bgp() {
  _get_bgp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee183(params) {
    return _regeneratorRuntime().wrap(function _callee183$(_context183) {
      while (1) switch (_context183.prev = _context183.next) {
        case 0:
          return _context183.abrupt("return", $.getJSON("/v1/company/get_bgp/", params));
        case 1:
        case "end":
          return _context183.stop();
      }
    }, _callee183);
  }));
  return _get_bgp.apply(this, arguments);
}
function create_bgp_normal(_x185) {
  return _create_bgp_normal.apply(this, arguments);
}
function _create_bgp_normal() {
  _create_bgp_normal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee184(params) {
    return _regeneratorRuntime().wrap(function _callee184$(_context184) {
      while (1) switch (_context184.prev = _context184.next) {
        case 0:
          return _context184.abrupt("return", $.post("/v1/company/create_bgp_normal/", params));
        case 1:
        case "end":
          return _context184.stop();
      }
    }, _callee184);
  }));
  return _create_bgp_normal.apply(this, arguments);
}
function update_bgp_normal(_x186) {
  return _update_bgp_normal.apply(this, arguments);
}
function _update_bgp_normal() {
  _update_bgp_normal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee185(params) {
    return _regeneratorRuntime().wrap(function _callee185$(_context185) {
      while (1) switch (_context185.prev = _context185.next) {
        case 0:
          return _context185.abrupt("return", $.post("/v1/company/update_bgp_normal/", params));
        case 1:
        case "end":
          return _context185.stop();
      }
    }, _callee185);
  }));
  return _update_bgp_normal.apply(this, arguments);
}
function delete_bgp_normal(_x187) {
  return _delete_bgp_normal.apply(this, arguments);
}
function _delete_bgp_normal() {
  _delete_bgp_normal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee186(params) {
    return _regeneratorRuntime().wrap(function _callee186$(_context186) {
      while (1) switch (_context186.prev = _context186.next) {
        case 0:
          return _context186.abrupt("return", $.post("/v1/company/delete_bgp_normal/", params));
        case 1:
        case "end":
          return _context186.stop();
      }
    }, _callee186);
  }));
  return _delete_bgp_normal.apply(this, arguments);
}
function get_cta_lan(_x188) {
  return _get_cta_lan.apply(this, arguments);
}
function _get_cta_lan() {
  _get_cta_lan = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee187(params) {
    return _regeneratorRuntime().wrap(function _callee187$(_context187) {
      while (1) switch (_context187.prev = _context187.next) {
        case 0:
          return _context187.abrupt("return", $.getJSON("/v1/company/get_cta_lan/", params));
        case 1:
        case "end":
          return _context187.stop();
      }
    }, _callee187);
  }));
  return _get_cta_lan.apply(this, arguments);
}
function get_port_detect(_x189) {
  return _get_port_detect.apply(this, arguments);
}
function _get_port_detect() {
  _get_port_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee188(params) {
    return _regeneratorRuntime().wrap(function _callee188$(_context188) {
      while (1) switch (_context188.prev = _context188.next) {
        case 0:
          return _context188.abrupt("return", $.getJSON("/v1/company/get_port_detect/", params));
        case 1:
        case "end":
          return _context188.stop();
      }
    }, _callee188);
  }));
  return _get_port_detect.apply(this, arguments);
}
function create_port_detect(_x190) {
  return _create_port_detect.apply(this, arguments);
}
function _create_port_detect() {
  _create_port_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee189(params) {
    return _regeneratorRuntime().wrap(function _callee189$(_context189) {
      while (1) switch (_context189.prev = _context189.next) {
        case 0:
          return _context189.abrupt("return", $.post("/v1/company/create_port_detect/", params));
        case 1:
        case "end":
          return _context189.stop();
      }
    }, _callee189);
  }));
  return _create_port_detect.apply(this, arguments);
}
function update_port_detect(_x191) {
  return _update_port_detect.apply(this, arguments);
}
function _update_port_detect() {
  _update_port_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee190(params) {
    return _regeneratorRuntime().wrap(function _callee190$(_context190) {
      while (1) switch (_context190.prev = _context190.next) {
        case 0:
          return _context190.abrupt("return", $.post("/v1/company/update_port_detect/", params));
        case 1:
        case "end":
          return _context190.stop();
      }
    }, _callee190);
  }));
  return _update_port_detect.apply(this, arguments);
}
function delete_port_detect(_x192) {
  return _delete_port_detect.apply(this, arguments);
}
function _delete_port_detect() {
  _delete_port_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee191(params) {
    return _regeneratorRuntime().wrap(function _callee191$(_context191) {
      while (1) switch (_context191.prev = _context191.next) {
        case 0:
          return _context191.abrupt("return", $.post("/v1/company/delete_port_detect/", params));
        case 1:
        case "end":
          return _context191.stop();
      }
    }, _callee191);
  }));
  return _delete_port_detect.apply(this, arguments);
}
function get_bgp_his(_x193) {
  return _get_bgp_his.apply(this, arguments);
}
function _get_bgp_his() {
  _get_bgp_his = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee192(params) {
    return _regeneratorRuntime().wrap(function _callee192$(_context192) {
      while (1) switch (_context192.prev = _context192.next) {
        case 0:
          return _context192.abrupt("return", $.getJSON("/v1/rate/get_bgp_his/", params));
        case 1:
        case "end":
          return _context192.stop();
      }
    }, _callee192);
  }));
  return _get_bgp_his.apply(this, arguments);
}
function get_app_account_stat(_x194) {
  return _get_app_account_stat.apply(this, arguments);
}
function _get_app_account_stat() {
  _get_app_account_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee193(params) {
    return _regeneratorRuntime().wrap(function _callee193$(_context193) {
      while (1) switch (_context193.prev = _context193.next) {
        case 0:
          return _context193.abrupt("return", $.getJSON("/v1/company/get_app_account_stat/", params));
        case 1:
        case "end":
          return _context193.stop();
      }
    }, _callee193);
  }));
  return _get_app_account_stat.apply(this, arguments);
}
function get_uci_command(_x195) {
  return _get_uci_command.apply(this, arguments);
}
function _get_uci_command() {
  _get_uci_command = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee194(params) {
    return _regeneratorRuntime().wrap(function _callee194$(_context194) {
      while (1) switch (_context194.prev = _context194.next) {
        case 0:
          return _context194.abrupt("return", $.getJSON("/v1/company/get_uci_command/", params));
        case 1:
        case "end":
          return _context194.stop();
      }
    }, _callee194);
  }));
  return _get_uci_command.apply(this, arguments);
}
function delete_uci_command(_x196) {
  return _delete_uci_command.apply(this, arguments);
}
function _delete_uci_command() {
  _delete_uci_command = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee195(params) {
    return _regeneratorRuntime().wrap(function _callee195$(_context195) {
      while (1) switch (_context195.prev = _context195.next) {
        case 0:
          return _context195.abrupt("return", $.deleteObj("/v1/company/delete_uci_command/", params));
        case 1:
        case "end":
          return _context195.stop();
      }
    }, _callee195);
  }));
  return _delete_uci_command.apply(this, arguments);
}
function get_center_links_bandwidth_stat(_x197) {
  return _get_center_links_bandwidth_stat.apply(this, arguments);
}
function _get_center_links_bandwidth_stat() {
  _get_center_links_bandwidth_stat = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee196(params) {
    return _regeneratorRuntime().wrap(function _callee196$(_context196) {
      while (1) switch (_context196.prev = _context196.next) {
        case 0:
          return _context196.abrupt("return", $.getJSON("/v1/company/get_center_links_bandwidth_stat/", params));
        case 1:
        case "end":
          return _context196.stop();
      }
    }, _callee196);
  }));
  return _get_center_links_bandwidth_stat.apply(this, arguments);
}
function get_bgp_ip(_x198) {
  return _get_bgp_ip.apply(this, arguments);
}
function _get_bgp_ip() {
  _get_bgp_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee197(params) {
    return _regeneratorRuntime().wrap(function _callee197$(_context197) {
      while (1) switch (_context197.prev = _context197.next) {
        case 0:
          return _context197.abrupt("return", $.getJSON("/v1/company/get_bgp_ip/", params));
        case 1:
        case "end":
          return _context197.stop();
      }
    }, _callee197);
  }));
  return _get_bgp_ip.apply(this, arguments);
}
function get_max_app_no(_x199) {
  return _get_max_app_no.apply(this, arguments);
}
function _get_max_app_no() {
  _get_max_app_no = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee198(params) {
    return _regeneratorRuntime().wrap(function _callee198$(_context198) {
      while (1) switch (_context198.prev = _context198.next) {
        case 0:
          return _context198.abrupt("return", $.getJSON("/v1/company/get_max_app_no/", params));
        case 1:
        case "end":
          return _context198.stop();
      }
    }, _callee198);
  }));
  return _get_max_app_no.apply(this, arguments);
}
function update_max_app_no(_x200) {
  return _update_max_app_no.apply(this, arguments);
}
function _update_max_app_no() {
  _update_max_app_no = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee199(params) {
    return _regeneratorRuntime().wrap(function _callee199$(_context199) {
      while (1) switch (_context199.prev = _context199.next) {
        case 0:
          return _context199.abrupt("return", $.post("/v1/company/update_max_app_no/", params));
        case 1:
        case "end":
          return _context199.stop();
      }
    }, _callee199);
  }));
  return _update_max_app_no.apply(this, arguments);
}
function get_l3_tunnel(_x201) {
  return _get_l3_tunnel.apply(this, arguments);
}
function _get_l3_tunnel() {
  _get_l3_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee200(params) {
    return _regeneratorRuntime().wrap(function _callee200$(_context200) {
      while (1) switch (_context200.prev = _context200.next) {
        case 0:
          return _context200.abrupt("return", $.getJSON("/v1/company/get_l3_tunnel/", params));
        case 1:
        case "end":
          return _context200.stop();
      }
    }, _callee200);
  }));
  return _get_l3_tunnel.apply(this, arguments);
}
function create_l3_tunnel(_x202) {
  return _create_l3_tunnel.apply(this, arguments);
}
function _create_l3_tunnel() {
  _create_l3_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee201(params) {
    return _regeneratorRuntime().wrap(function _callee201$(_context201) {
      while (1) switch (_context201.prev = _context201.next) {
        case 0:
          return _context201.abrupt("return", $.post("/v1/company/create_l3_tunnel/", params));
        case 1:
        case "end":
          return _context201.stop();
      }
    }, _callee201);
  }));
  return _create_l3_tunnel.apply(this, arguments);
}
function update_l3_tunnel(_x203) {
  return _update_l3_tunnel.apply(this, arguments);
}
function _update_l3_tunnel() {
  _update_l3_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee202(params) {
    return _regeneratorRuntime().wrap(function _callee202$(_context202) {
      while (1) switch (_context202.prev = _context202.next) {
        case 0:
          return _context202.abrupt("return", $.post("/v1/company/update_l3_tunnel/", params));
        case 1:
        case "end":
          return _context202.stop();
      }
    }, _callee202);
  }));
  return _update_l3_tunnel.apply(this, arguments);
}
function delete_l3_tunnel(_x204) {
  return _delete_l3_tunnel.apply(this, arguments);
}
function _delete_l3_tunnel() {
  _delete_l3_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee203(params) {
    return _regeneratorRuntime().wrap(function _callee203$(_context203) {
      while (1) switch (_context203.prev = _context203.next) {
        case 0:
          return _context203.abrupt("return", $.post("/v1/company/delete_l3_tunnel/", params));
        case 1:
        case "end":
          return _context203.stop();
      }
    }, _callee203);
  }));
  return _delete_l3_tunnel.apply(this, arguments);
}
function reset_stock(_x205) {
  return _reset_stock.apply(this, arguments);
}
function _reset_stock() {
  _reset_stock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee204(params) {
    return _regeneratorRuntime().wrap(function _callee204$(_context204) {
      while (1) switch (_context204.prev = _context204.next) {
        case 0:
          return _context204.abrupt("return", $.post("/v1/company/reset_stock/", params));
        case 1:
        case "end":
          return _context204.stop();
      }
    }, _callee204);
  }));
  return _reset_stock.apply(this, arguments);
}
function get_device_lifetime(_x206) {
  return _get_device_lifetime.apply(this, arguments);
}
function _get_device_lifetime() {
  _get_device_lifetime = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee205(params) {
    return _regeneratorRuntime().wrap(function _callee205$(_context205) {
      while (1) switch (_context205.prev = _context205.next) {
        case 0:
          return _context205.abrupt("return", $.getJSON("/v1/company/get_device_lifetime/", params));
        case 1:
        case "end":
          return _context205.stop();
      }
    }, _callee205);
  }));
  return _get_device_lifetime.apply(this, arguments);
}
function get_healthy_status(_x207) {
  return _get_healthy_status.apply(this, arguments);
}
function _get_healthy_status() {
  _get_healthy_status = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee206(params) {
    return _regeneratorRuntime().wrap(function _callee206$(_context206) {
      while (1) switch (_context206.prev = _context206.next) {
        case 0:
          return _context206.abrupt("return", $.getJSON("/v1/company/get_healthy_status/", params));
        case 1:
        case "end":
          return _context206.stop();
      }
    }, _callee206);
  }));
  return _get_healthy_status.apply(this, arguments);
}
function get_filter_rule(_x208) {
  return _get_filter_rule.apply(this, arguments);
}
function _get_filter_rule() {
  _get_filter_rule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee207(params) {
    return _regeneratorRuntime().wrap(function _callee207$(_context207) {
      while (1) switch (_context207.prev = _context207.next) {
        case 0:
          return _context207.abrupt("return", $.post("/alarm/api/v1/alarm/filter_rule/", params));
        case 1:
        case "end":
          return _context207.stop();
      }
    }, _callee207);
  }));
  return _get_filter_rule.apply(this, arguments);
}
function put_filter_rule(_x209) {
  return _put_filter_rule.apply(this, arguments);
}
function _put_filter_rule() {
  _put_filter_rule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee208(params) {
    return _regeneratorRuntime().wrap(function _callee208$(_context208) {
      while (1) switch (_context208.prev = _context208.next) {
        case 0:
          return _context208.abrupt("return", $.put("/alarm/api/v1/alarm/filter_rule/", params));
        case 1:
        case "end":
          return _context208.stop();
      }
    }, _callee208);
  }));
  return _put_filter_rule.apply(this, arguments);
}
function delete_filter_rule(_x210) {
  return _delete_filter_rule.apply(this, arguments);
}
function _delete_filter_rule() {
  _delete_filter_rule = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee209(params) {
    return _regeneratorRuntime().wrap(function _callee209$(_context209) {
      while (1) switch (_context209.prev = _context209.next) {
        case 0:
          return _context209.abrupt("return", $.getJSON("/alarm/api/v1/alarm/filter_rule/delete/", params));
        case 1:
        case "end":
          return _context209.stop();
      }
    }, _callee209);
  }));
  return _delete_filter_rule.apply(this, arguments);
}
function push_config_old(_x211) {
  return _push_config_old.apply(this, arguments);
}
function _push_config_old() {
  _push_config_old = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee210(params) {
    return _regeneratorRuntime().wrap(function _callee210$(_context210) {
      while (1) switch (_context210.prev = _context210.next) {
        case 0:
          return _context210.abrupt("return", $.post("/v1/company/push_config_old/", params));
        case 1:
        case "end":
          return _context210.stop();
      }
    }, _callee210);
  }));
  return _push_config_old.apply(this, arguments);
}
function get_boss_uic_use(_x212) {
  return _get_boss_uic_use.apply(this, arguments);
}
function _get_boss_uic_use() {
  _get_boss_uic_use = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee211(params) {
    return _regeneratorRuntime().wrap(function _callee211$(_context211) {
      while (1) switch (_context211.prev = _context211.next) {
        case 0:
          return _context211.abrupt("return", $.getJSON("/alarm/api/v1/boss/uic/user/", params));
        case 1:
        case "end":
          return _context211.stop();
      }
    }, _callee211);
  }));
  return _get_boss_uic_use.apply(this, arguments);
}
function post_boss_uic_use(_x213) {
  return _post_boss_uic_use.apply(this, arguments);
}
function _post_boss_uic_use() {
  _post_boss_uic_use = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee212(params) {
    return _regeneratorRuntime().wrap(function _callee212$(_context212) {
      while (1) switch (_context212.prev = _context212.next) {
        case 0:
          return _context212.abrupt("return", $.post("/alarm/api/v1/boss/uic/user/", params));
        case 1:
        case "end":
          return _context212.stop();
      }
    }, _callee212);
  }));
  return _post_boss_uic_use.apply(this, arguments);
}
function get_strategy_label(_x214) {
  return _get_strategy_label.apply(this, arguments);
}
function _get_strategy_label() {
  _get_strategy_label = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee213(params) {
    return _regeneratorRuntime().wrap(function _callee213$(_context213) {
      while (1) switch (_context213.prev = _context213.next) {
        case 0:
          return _context213.abrupt("return", $.getJSON("/alarm/api/v1/strategy_label/", params));
        case 1:
        case "end":
          return _context213.stop();
      }
    }, _callee213);
  }));
  return _get_strategy_label.apply(this, arguments);
}
function get_deleted_link(_x215) {
  return _get_deleted_link.apply(this, arguments);
}
function _get_deleted_link() {
  _get_deleted_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee214(params) {
    return _regeneratorRuntime().wrap(function _callee214$(_context214) {
      while (1) switch (_context214.prev = _context214.next) {
        case 0:
          return _context214.abrupt("return", $.getJSON("/v1/company/get_deleted_link/", params));
        case 1:
        case "end":
          return _context214.stop();
      }
    }, _callee214);
  }));
  return _get_deleted_link.apply(this, arguments);
}
function get_all_alarms_count(_x216) {
  return _get_all_alarms_count.apply(this, arguments);
}
function _get_all_alarms_count() {
  _get_all_alarms_count = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee215(params) {
    return _regeneratorRuntime().wrap(function _callee215$(_context215) {
      while (1) switch (_context215.prev = _context215.next) {
        case 0:
          return _context215.abrupt("return", $.post("/alarm/api/v1/alarm/all_alarms/count/", params));
        case 1:
        case "end":
          return _context215.stop();
      }
    }, _callee215);
  }));
  return _get_all_alarms_count.apply(this, arguments);
}
function post_all_alarms(_x217) {
  return _post_all_alarms.apply(this, arguments);
}
function _post_all_alarms() {
  _post_all_alarms = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee216(params) {
    return _regeneratorRuntime().wrap(function _callee216$(_context216) {
      while (1) switch (_context216.prev = _context216.next) {
        case 0:
          return _context216.abrupt("return", $.post("/alarm/api/v1/alarm/all_alarms/", params));
        case 1:
        case "end":
          return _context216.stop();
      }
    }, _callee216);
  }));
  return _post_all_alarms.apply(this, arguments);
}
function get_company_url(_x218) {
  return _get_company_url.apply(this, arguments);
}
function _get_company_url() {
  _get_company_url = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee217(params) {
    return _regeneratorRuntime().wrap(function _callee217$(_context217) {
      while (1) switch (_context217.prev = _context217.next) {
        case 0:
          return _context217.abrupt("return", $.getJSON("/v1/company/get_company_url/", params));
        case 1:
        case "end":
          return _context217.stop();
      }
    }, _callee217);
  }));
  return _get_company_url.apply(this, arguments);
}
function update_company_url(_x219) {
  return _update_company_url.apply(this, arguments);
}
function _update_company_url() {
  _update_company_url = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee218(params) {
    return _regeneratorRuntime().wrap(function _callee218$(_context218) {
      while (1) switch (_context218.prev = _context218.next) {
        case 0:
          return _context218.abrupt("return", $.post("/v1/company/update_company_url/", params));
        case 1:
        case "end":
          return _context218.stop();
      }
    }, _callee218);
  }));
  return _update_company_url.apply(this, arguments);
}
function get_app_account_group(_x220) {
  return _get_app_account_group.apply(this, arguments);
}
function _get_app_account_group() {
  _get_app_account_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee219(params) {
    return _regeneratorRuntime().wrap(function _callee219$(_context219) {
      while (1) switch (_context219.prev = _context219.next) {
        case 0:
          return _context219.abrupt("return", $.getJSON("/v1/company/get_app_account_group/", params));
        case 1:
        case "end":
          return _context219.stop();
      }
    }, _callee219);
  }));
  return _get_app_account_group.apply(this, arguments);
}
function get_resource_group(_x221) {
  return _get_resource_group.apply(this, arguments);
}
function _get_resource_group() {
  _get_resource_group = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee220(params) {
    return _regeneratorRuntime().wrap(function _callee220$(_context220) {
      while (1) switch (_context220.prev = _context220.next) {
        case 0:
          return _context220.abrupt("return", $.getJSON("/v1/company/get_resource_group/", params));
        case 1:
        case "end":
          return _context220.stop();
      }
    }, _callee220);
  }));
  return _get_resource_group.apply(this, arguments);
}
function get_centre_agency(_x222) {
  return _get_centre_agency.apply(this, arguments);
}
function _get_centre_agency() {
  _get_centre_agency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee221(params) {
    return _regeneratorRuntime().wrap(function _callee221$(_context221) {
      while (1) switch (_context221.prev = _context221.next) {
        case 0:
          return _context221.abrupt("return", $.getJSON("/v1/company/get_centre_agency/", params));
        case 1:
        case "end":
          return _context221.stop();
      }
    }, _callee221);
  }));
  return _get_centre_agency.apply(this, arguments);
}
function create_app_account_link(_x223) {
  return _create_app_account_link.apply(this, arguments);
}
function _create_app_account_link() {
  _create_app_account_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee222(params) {
    return _regeneratorRuntime().wrap(function _callee222$(_context222) {
      while (1) switch (_context222.prev = _context222.next) {
        case 0:
          return _context222.abrupt("return", $.post("/v1/company/create_app_account_link/", params));
        case 1:
        case "end":
          return _context222.stop();
      }
    }, _callee222);
  }));
  return _create_app_account_link.apply(this, arguments);
}
function update_app_account_link(_x224) {
  return _update_app_account_link.apply(this, arguments);
}
function _update_app_account_link() {
  _update_app_account_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee223(params) {
    return _regeneratorRuntime().wrap(function _callee223$(_context223) {
      while (1) switch (_context223.prev = _context223.next) {
        case 0:
          return _context223.abrupt("return", $.post("/v1/company/update_app_account_link/", params));
        case 1:
        case "end":
          return _context223.stop();
      }
    }, _callee223);
  }));
  return _update_app_account_link.apply(this, arguments);
}
function all_company_update(_x225) {
  return _all_company_update.apply(this, arguments);
}
function _all_company_update() {
  _all_company_update = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee224(params) {
    return _regeneratorRuntime().wrap(function _callee224$(_context224) {
      while (1) switch (_context224.prev = _context224.next) {
        case 0:
          return _context224.abrupt("return", $.getJSON("/v1/company/all_company_update/", params));
        case 1:
        case "end":
          return _context224.stop();
      }
    }, _callee224);
  }));
  return _all_company_update.apply(this, arguments);
}
function get_controllers(_x226) {
  return _get_controllers.apply(this, arguments);
}
function _get_controllers() {
  _get_controllers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee225(params) {
    return _regeneratorRuntime().wrap(function _callee225$(_context225) {
      while (1) switch (_context225.prev = _context225.next) {
        case 0:
          return _context225.abrupt("return", $.getJSON("/v1/company/get_controllers/", params));
        case 1:
        case "end":
          return _context225.stop();
      }
    }, _callee225);
  }));
  return _get_controllers.apply(this, arguments);
}
function get_controller_companys(_x227) {
  return _get_controller_companys.apply(this, arguments);
}
function _get_controller_companys() {
  _get_controller_companys = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee226(params) {
    return _regeneratorRuntime().wrap(function _callee226$(_context226) {
      while (1) switch (_context226.prev = _context226.next) {
        case 0:
          return _context226.abrupt("return", $.getJSON("/v1/company/get_controller_companys/", params));
        case 1:
        case "end":
          return _context226.stop();
      }
    }, _callee226);
  }));
  return _get_controller_companys.apply(this, arguments);
}
function create_controller(_x228) {
  return _create_controller.apply(this, arguments);
}
function _create_controller() {
  _create_controller = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee227(params) {
    return _regeneratorRuntime().wrap(function _callee227$(_context227) {
      while (1) switch (_context227.prev = _context227.next) {
        case 0:
          return _context227.abrupt("return", $.post("/v1/company/create_controller/", params));
        case 1:
        case "end":
          return _context227.stop();
      }
    }, _callee227);
  }));
  return _create_controller.apply(this, arguments);
}
function update_controller(_x229) {
  return _update_controller.apply(this, arguments);
}
function _update_controller() {
  _update_controller = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee228(params) {
    return _regeneratorRuntime().wrap(function _callee228$(_context228) {
      while (1) switch (_context228.prev = _context228.next) {
        case 0:
          return _context228.abrupt("return", $.post("/v1/company/update_controller/", params));
        case 1:
        case "end":
          return _context228.stop();
      }
    }, _callee228);
  }));
  return _update_controller.apply(this, arguments);
}
function update_company_controller(_x230) {
  return _update_company_controller.apply(this, arguments);
}
function _update_company_controller() {
  _update_company_controller = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee229(params) {
    return _regeneratorRuntime().wrap(function _callee229$(_context229) {
      while (1) switch (_context229.prev = _context229.next) {
        case 0:
          return _context229.abrupt("return", $.post("/v1/company/update_company_controller/", params));
        case 1:
        case "end":
          return _context229.stop();
      }
    }, _callee229);
  }));
  return _update_company_controller.apply(this, arguments);
}
function delete_controller(_x231) {
  return _delete_controller.apply(this, arguments);
}
function _delete_controller() {
  _delete_controller = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee230(params) {
    return _regeneratorRuntime().wrap(function _callee230$(_context230) {
      while (1) switch (_context230.prev = _context230.next) {
        case 0:
          return _context230.abrupt("return", $.post("/v1/company/delete_controller/", params));
        case 1:
        case "end":
          return _context230.stop();
      }
    }, _callee230);
  }));
  return _delete_controller.apply(this, arguments);
}
function get_bill_link_info(_x232) {
  return _get_bill_link_info.apply(this, arguments);
}
function _get_bill_link_info() {
  _get_bill_link_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee231(params) {
    return _regeneratorRuntime().wrap(function _callee231$(_context231) {
      while (1) switch (_context231.prev = _context231.next) {
        case 0:
          return _context231.abrupt("return", $.getJSON("/v1/company/get_bill_link_info/", params));
        case 1:
        case "end":
          return _context231.stop();
      }
    }, _callee231);
  }));
  return _get_bill_link_info.apply(this, arguments);
}
function get_manual_strategy(_x233) {
  return _get_manual_strategy.apply(this, arguments);
}
function _get_manual_strategy() {
  _get_manual_strategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee232(params) {
    return _regeneratorRuntime().wrap(function _callee232$(_context232) {
      while (1) switch (_context232.prev = _context232.next) {
        case 0:
          return _context232.abrupt("return", $.getJSON("/v1/company/get_manual_strategy/", params));
        case 1:
        case "end":
          return _context232.stop();
      }
    }, _callee232);
  }));
  return _get_manual_strategy.apply(this, arguments);
}
function get_area_info(_x234) {
  return _get_area_info.apply(this, arguments);
}
function _get_area_info() {
  _get_area_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee233(params) {
    return _regeneratorRuntime().wrap(function _callee233$(_context233) {
      while (1) switch (_context233.prev = _context233.next) {
        case 0:
          return _context233.abrupt("return", $.getJSON("/v1/company/get_area_info/", params));
        case 1:
        case "end":
          return _context233.stop();
      }
    }, _callee233);
  }));
  return _get_area_info.apply(this, arguments);
}
function get_device_sn(_x235) {
  return _get_device_sn.apply(this, arguments);
}
function _get_device_sn() {
  _get_device_sn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee234(params) {
    return _regeneratorRuntime().wrap(function _callee234$(_context234) {
      while (1) switch (_context234.prev = _context234.next) {
        case 0:
          return _context234.abrupt("return", $.getJSON("/v1/company/get_device_sn/", params));
        case 1:
        case "end":
          return _context234.stop();
      }
    }, _callee234);
  }));
  return _get_device_sn.apply(this, arguments);
}
function get_province_rooms(_x236) {
  return _get_province_rooms.apply(this, arguments);
}
function _get_province_rooms() {
  _get_province_rooms = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee235(params) {
    return _regeneratorRuntime().wrap(function _callee235$(_context235) {
      while (1) switch (_context235.prev = _context235.next) {
        case 0:
          return _context235.abrupt("return", $.getJSON("/v1/company/get_province_rooms/", params));
        case 1:
        case "end":
          return _context235.stop();
      }
    }, _callee235);
  }));
  return _get_province_rooms.apply(this, arguments);
}
function create_manual_strategy(_x237) {
  return _create_manual_strategy.apply(this, arguments);
}
function _create_manual_strategy() {
  _create_manual_strategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee236(params) {
    return _regeneratorRuntime().wrap(function _callee236$(_context236) {
      while (1) switch (_context236.prev = _context236.next) {
        case 0:
          return _context236.abrupt("return", $.post("/v1/company/create_manual_strategy/", params));
        case 1:
        case "end":
          return _context236.stop();
      }
    }, _callee236);
  }));
  return _create_manual_strategy.apply(this, arguments);
}
function delete_manual_strategy(_x238) {
  return _delete_manual_strategy.apply(this, arguments);
}
function _delete_manual_strategy() {
  _delete_manual_strategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee237(params) {
    return _regeneratorRuntime().wrap(function _callee237$(_context237) {
      while (1) switch (_context237.prev = _context237.next) {
        case 0:
          return _context237.abrupt("return", $.post("/v1/company/delete_manual_strategy/", params));
        case 1:
        case "end":
          return _context237.stop();
      }
    }, _callee237);
  }));
  return _delete_manual_strategy.apply(this, arguments);
}
function update_manual_strategy(_x239) {
  return _update_manual_strategy.apply(this, arguments);
}
function _update_manual_strategy() {
  _update_manual_strategy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee238(params) {
    return _regeneratorRuntime().wrap(function _callee238$(_context238) {
      while (1) switch (_context238.prev = _context238.next) {
        case 0:
          return _context238.abrupt("return", $.post("/v1/company/update_manual_strategy/", params));
        case 1:
        case "end":
          return _context238.stop();
      }
    }, _callee238);
  }));
  return _update_manual_strategy.apply(this, arguments);
}
function search_controller_company(_x240) {
  return _search_controller_company.apply(this, arguments);
}
function _search_controller_company() {
  _search_controller_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee239(params) {
    return _regeneratorRuntime().wrap(function _callee239$(_context239) {
      while (1) switch (_context239.prev = _context239.next) {
        case 0:
          return _context239.abrupt("return", $.getJSON("/v1/company/search_controller_company/", params));
        case 1:
        case "end":
          return _context239.stop();
      }
    }, _callee239);
  }));
  return _search_controller_company.apply(this, arguments);
}
function check_move_device(_x241) {
  return _check_move_device.apply(this, arguments);
}
function _check_move_device() {
  _check_move_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee240(params) {
    return _regeneratorRuntime().wrap(function _callee240$(_context240) {
      while (1) switch (_context240.prev = _context240.next) {
        case 0:
          return _context240.abrupt("return", $.getJSON("/v1/company/check_move_device/", params));
        case 1:
        case "end":
          return _context240.stop();
      }
    }, _callee240);
  }));
  return _check_move_device.apply(this, arguments);
}
function get_dpi_feature(_x242) {
  return _get_dpi_feature.apply(this, arguments);
}
function _get_dpi_feature() {
  _get_dpi_feature = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee241(params) {
    return _regeneratorRuntime().wrap(function _callee241$(_context241) {
      while (1) switch (_context241.prev = _context241.next) {
        case 0:
          return _context241.abrupt("return", $.getJSON("/v1/company/get_dpi_feature/", params));
        case 1:
        case "end":
          return _context241.stop();
      }
    }, _callee241);
  }));
  return _get_dpi_feature.apply(this, arguments);
}
function get_wan_isp_info(_x243) {
  return _get_wan_isp_info.apply(this, arguments);
}
function _get_wan_isp_info() {
  _get_wan_isp_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee242(params) {
    return _regeneratorRuntime().wrap(function _callee242$(_context242) {
      while (1) switch (_context242.prev = _context242.next) {
        case 0:
          return _context242.abrupt("return", $.getJSON("/v1/company/get_wan_isp_info/", params));
        case 1:
        case "end":
          return _context242.stop();
      }
    }, _callee242);
  }));
  return _get_wan_isp_info.apply(this, arguments);
}
function send_script_list(_x244) {
  return _send_script_list.apply(this, arguments);
}
function _send_script_list() {
  _send_script_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee243(params) {
    return _regeneratorRuntime().wrap(function _callee243$(_context243) {
      while (1) switch (_context243.prev = _context243.next) {
        case 0:
          return _context243.abrupt("return", $.post("/v1/company/send_script_list/", params));
        case 1:
        case "end":
          return _context243.stop();
      }
    }, _callee243);
  }));
  return _send_script_list.apply(this, arguments);
}
function get_link_detect_info(_x245) {
  return _get_link_detect_info.apply(this, arguments);
}
function _get_link_detect_info() {
  _get_link_detect_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee244(params) {
    return _regeneratorRuntime().wrap(function _callee244$(_context244) {
      while (1) switch (_context244.prev = _context244.next) {
        case 0:
          return _context244.abrupt("return", $.getJSON("/v1/company/get_link_detect_info/", params));
        case 1:
        case "end":
          return _context244.stop();
      }
    }, _callee244);
  }));
  return _get_link_detect_info.apply(this, arguments);
}
function create_link_detect_info(_x246) {
  return _create_link_detect_info.apply(this, arguments);
}
function _create_link_detect_info() {
  _create_link_detect_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee245(params) {
    return _regeneratorRuntime().wrap(function _callee245$(_context245) {
      while (1) switch (_context245.prev = _context245.next) {
        case 0:
          return _context245.abrupt("return", $.post("/v1/company/create_link_detect_info/", params));
        case 1:
        case "end":
          return _context245.stop();
      }
    }, _callee245);
  }));
  return _create_link_detect_info.apply(this, arguments);
}
function delete_link_detect_info(_x247) {
  return _delete_link_detect_info.apply(this, arguments);
}
function _delete_link_detect_info() {
  _delete_link_detect_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee246(params) {
    return _regeneratorRuntime().wrap(function _callee246$(_context246) {
      while (1) switch (_context246.prev = _context246.next) {
        case 0:
          return _context246.abrupt("return", $.post("/v1/company/delete_link_detect_info/", params));
        case 1:
        case "end":
          return _context246.stop();
      }
    }, _callee246);
  }));
  return _delete_link_detect_info.apply(this, arguments);
}
function get_agency_ip_of_device(_x248) {
  return _get_agency_ip_of_device.apply(this, arguments);
}
function _get_agency_ip_of_device() {
  _get_agency_ip_of_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee247(params) {
    return _regeneratorRuntime().wrap(function _callee247$(_context247) {
      while (1) switch (_context247.prev = _context247.next) {
        case 0:
          return _context247.abrupt("return", $.getJSON("/v1/company/get_agency_ip_of_device/", params));
        case 1:
        case "end":
          return _context247.stop();
      }
    }, _callee247);
  }));
  return _get_agency_ip_of_device.apply(this, arguments);
}
function check_ip_in_agency_ip(_x249) {
  return _check_ip_in_agency_ip.apply(this, arguments);
}
function _check_ip_in_agency_ip() {
  _check_ip_in_agency_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee248(params) {
    return _regeneratorRuntime().wrap(function _callee248$(_context248) {
      while (1) switch (_context248.prev = _context248.next) {
        case 0:
          return _context248.abrupt("return", $.post("/v1/company/check_ip_in_agency_ip/", params));
        case 1:
        case "end":
          return _context248.stop();
      }
    }, _callee248);
  }));
  return _check_ip_in_agency_ip.apply(this, arguments);
}
function get_agency_ip_of_link(_x250) {
  return _get_agency_ip_of_link.apply(this, arguments);
}
function _get_agency_ip_of_link() {
  _get_agency_ip_of_link = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee249(params) {
    return _regeneratorRuntime().wrap(function _callee249$(_context249) {
      while (1) switch (_context249.prev = _context249.next) {
        case 0:
          return _context249.abrupt("return", $.getJSON("/v1/company/get_agency_ip_of_link/", params));
        case 1:
        case "end":
          return _context249.stop();
      }
    }, _callee249);
  }));
  return _get_agency_ip_of_link.apply(this, arguments);
}
function cstep_device_changed(_x251) {
  return _cstep_device_changed.apply(this, arguments);
}
function _cstep_device_changed() {
  _cstep_device_changed = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee250(params) {
    return _regeneratorRuntime().wrap(function _callee250$(_context250) {
      while (1) switch (_context250.prev = _context250.next) {
        case 0:
          return _context250.abrupt("return", $.getJSON("/v1/company/cstep_device_changed/", params));
        case 1:
        case "end":
          return _context250.stop();
      }
    }, _callee250);
  }));
  return _cstep_device_changed.apply(this, arguments);
}
function get_port_series(_x252) {
  return _get_port_series.apply(this, arguments);
}
function _get_port_series() {
  _get_port_series = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee251(params) {
    return _regeneratorRuntime().wrap(function _callee251$(_context251) {
      while (1) switch (_context251.prev = _context251.next) {
        case 0:
          return _context251.abrupt("return", $.getJSON("/v1/company/get_port_series/", params));
        case 1:
        case "end":
          return _context251.stop();
      }
    }, _callee251);
  }));
  return _get_port_series.apply(this, arguments);
}
function get_app_log(_x253) {
  return _get_app_log.apply(this, arguments);
}
function _get_app_log() {
  _get_app_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee252(params) {
    return _regeneratorRuntime().wrap(function _callee252$(_context252) {
      while (1) switch (_context252.prev = _context252.next) {
        case 0:
          return _context252.abrupt("return", $.getJSON("/v1/company/get_app_log/", params));
        case 1:
        case "end":
          return _context252.stop();
      }
    }, _callee252);
  }));
  return _get_app_log.apply(this, arguments);
}
function create_static_domain_list(_x254) {
  return _create_static_domain_list.apply(this, arguments);
}
function _create_static_domain_list() {
  _create_static_domain_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee253(params) {
    return _regeneratorRuntime().wrap(function _callee253$(_context253) {
      while (1) switch (_context253.prev = _context253.next) {
        case 0:
          return _context253.abrupt("return", $.post("/v1/company/create_static_domain_list/", params));
        case 1:
        case "end":
          return _context253.stop();
      }
    }, _callee253);
  }));
  return _create_static_domain_list.apply(this, arguments);
}
function create_upgrade_record(_x255) {
  return _create_upgrade_record.apply(this, arguments);
}
function _create_upgrade_record() {
  _create_upgrade_record = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee254(params) {
    return _regeneratorRuntime().wrap(function _callee254$(_context254) {
      while (1) switch (_context254.prev = _context254.next) {
        case 0:
          return _context254.abrupt("return", $.post("/v1/company/create_upgrade_record/", params));
        case 1:
        case "end":
          return _context254.stop();
      }
    }, _callee254);
  }));
  return _create_upgrade_record.apply(this, arguments);
}
function get_update_device(_x256) {
  return _get_update_device.apply(this, arguments);
}
function _get_update_device() {
  _get_update_device = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee255(params) {
    return _regeneratorRuntime().wrap(function _callee255$(_context255) {
      while (1) switch (_context255.prev = _context255.next) {
        case 0:
          return _context255.abrupt("return", $.post("/v1/company/get_update_device/", params));
        case 1:
        case "end":
          return _context255.stop();
      }
    }, _callee255);
  }));
  return _get_update_device.apply(this, arguments);
}
function upgrade_company(_x257) {
  return _upgrade_company.apply(this, arguments);
}
function _upgrade_company() {
  _upgrade_company = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee256(params) {
    return _regeneratorRuntime().wrap(function _callee256$(_context256) {
      while (1) switch (_context256.prev = _context256.next) {
        case 0:
          return _context256.abrupt("return", $.post("/v1/company/upgrade_company/", params));
        case 1:
        case "end":
          return _context256.stop();
      }
    }, _callee256);
  }));
  return _upgrade_company.apply(this, arguments);
}
function get_company_log_status(_x258) {
  return _get_company_log_status.apply(this, arguments);
}
function _get_company_log_status() {
  _get_company_log_status = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee257(params) {
    return _regeneratorRuntime().wrap(function _callee257$(_context257) {
      while (1) switch (_context257.prev = _context257.next) {
        case 0:
          return _context257.abrupt("return", $.getJSON("/v1/company/get_company_log_status/", params));
        case 1:
        case "end":
          return _context257.stop();
      }
    }, _callee257);
  }));
  return _get_company_log_status.apply(this, arguments);
}
function export_company_log(_x259) {
  return _export_company_log.apply(this, arguments);
}
function _export_company_log() {
  _export_company_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee258(params) {
    return _regeneratorRuntime().wrap(function _callee258$(_context258) {
      while (1) switch (_context258.prev = _context258.next) {
        case 0:
          return _context258.abrupt("return", $.getJSON("/v1/company/export_company_log/", params));
        case 1:
        case "end":
          return _context258.stop();
      }
    }, _callee258);
  }));
  return _export_company_log.apply(this, arguments);
}
function cancel_company_log(_x260) {
  return _cancel_company_log.apply(this, arguments);
}
function _cancel_company_log() {
  _cancel_company_log = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee259(params) {
    return _regeneratorRuntime().wrap(function _callee259$(_context259) {
      while (1) switch (_context259.prev = _context259.next) {
        case 0:
          return _context259.abrupt("return", $.getJSON("/v1/company/cancel_company_log/", params));
        case 1:
        case "end":
          return _context259.stop();
      }
    }, _callee259);
  }));
  return _cancel_company_log.apply(this, arguments);
}
function create_manual_link_path_bulk(_x261) {
  return _create_manual_link_path_bulk.apply(this, arguments);
}
function _create_manual_link_path_bulk() {
  _create_manual_link_path_bulk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee260(params) {
    return _regeneratorRuntime().wrap(function _callee260$(_context260) {
      while (1) switch (_context260.prev = _context260.next) {
        case 0:
          return _context260.abrupt("return", $.post("/v1/company/create_manual_link_path_bulk/", params));
        case 1:
        case "end":
          return _context260.stop();
      }
    }, _callee260);
  }));
  return _create_manual_link_path_bulk.apply(this, arguments);
}
function create_script_file(_x262) {
  return _create_script_file.apply(this, arguments);
}
function _create_script_file() {
  _create_script_file = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee261(params) {
    return _regeneratorRuntime().wrap(function _callee261$(_context261) {
      while (1) switch (_context261.prev = _context261.next) {
        case 0:
          return _context261.abrupt("return", $.post("/v1/company/create_script_file/", params));
        case 1:
        case "end":
          return _context261.stop();
      }
    }, _callee261);
  }));
  return _create_script_file.apply(this, arguments);
}
function update_script_file(_x263) {
  return _update_script_file.apply(this, arguments);
}
function _update_script_file() {
  _update_script_file = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee262(params) {
    return _regeneratorRuntime().wrap(function _callee262$(_context262) {
      while (1) switch (_context262.prev = _context262.next) {
        case 0:
          return _context262.abrupt("return", $.post("/v1/company/update_script_file/", params));
        case 1:
        case "end":
          return _context262.stop();
      }
    }, _callee262);
  }));
  return _update_script_file.apply(this, arguments);
}
function delete_script_file(_x264) {
  return _delete_script_file.apply(this, arguments);
}
function _delete_script_file() {
  _delete_script_file = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee263(params) {
    return _regeneratorRuntime().wrap(function _callee263$(_context263) {
      while (1) switch (_context263.prev = _context263.next) {
        case 0:
          return _context263.abrupt("return", $.post("/v1/company/delete_script_file/", params));
        case 1:
        case "end":
          return _context263.stop();
      }
    }, _callee263);
  }));
  return _delete_script_file.apply(this, arguments);
}
function get_script_file(_x265) {
  return _get_script_file.apply(this, arguments);
}
function _get_script_file() {
  _get_script_file = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee264(params) {
    return _regeneratorRuntime().wrap(function _callee264$(_context264) {
      while (1) switch (_context264.prev = _context264.next) {
        case 0:
          return _context264.abrupt("return", $.getJSON("/v1/company/get_script_file/", params));
        case 1:
        case "end":
          return _context264.stop();
      }
    }, _callee264);
  }));
  return _get_script_file.apply(this, arguments);
}
function get_address_tree(_x266) {
  return _get_address_tree.apply(this, arguments);
}
function _get_address_tree() {
  _get_address_tree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee265(params) {
    return _regeneratorRuntime().wrap(function _callee265$(_context265) {
      while (1) switch (_context265.prev = _context265.next) {
        case 0:
          return _context265.abrupt("return", $.getJSON("/v1/company/get_address_tree/", params));
        case 1:
        case "end":
          return _context265.stop();
      }
    }, _callee265);
  }));
  return _get_address_tree.apply(this, arguments);
}
function post_display_manual_path(_x267) {
  return _post_display_manual_path.apply(this, arguments);
}
function _post_display_manual_path() {
  _post_display_manual_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee266(params) {
    return _regeneratorRuntime().wrap(function _callee266$(_context266) {
      while (1) switch (_context266.prev = _context266.next) {
        case 0:
          return _context266.abrupt("return", $.post("/v1/company/display_manual_path/", params));
        case 1:
        case "end":
          return _context266.stop();
      }
    }, _callee266);
  }));
  return _post_display_manual_path.apply(this, arguments);
}
function post_display_manual_path_bulk(_x268) {
  return _post_display_manual_path_bulk.apply(this, arguments);
}
function _post_display_manual_path_bulk() {
  _post_display_manual_path_bulk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee267(params) {
    return _regeneratorRuntime().wrap(function _callee267$(_context267) {
      while (1) switch (_context267.prev = _context267.next) {
        case 0:
          return _context267.abrupt("return", $.post("/v1/company/display_manual_path_bulk/", params));
        case 1:
        case "end":
          return _context267.stop();
      }
    }, _callee267);
  }));
  return _post_display_manual_path_bulk.apply(this, arguments);
}
function create_reverse_tunnel(_x269) {
  return _create_reverse_tunnel.apply(this, arguments);
}
function _create_reverse_tunnel() {
  _create_reverse_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee268(params) {
    return _regeneratorRuntime().wrap(function _callee268$(_context268) {
      while (1) switch (_context268.prev = _context268.next) {
        case 0:
          return _context268.abrupt("return", $.getJSON("/api/create_reverse_tunnel/", params));
        case 1:
        case "end":
          return _context268.stop();
      }
    }, _callee268);
  }));
  return _create_reverse_tunnel.apply(this, arguments);
}
function commit_domain_list(_x270) {
  return _commit_domain_list.apply(this, arguments);
}
function _commit_domain_list() {
  _commit_domain_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee269(params) {
    return _regeneratorRuntime().wrap(function _callee269$(_context269) {
      while (1) switch (_context269.prev = _context269.next) {
        case 0:
          return _context269.abrupt("return", $.post("/v1/company/commit_domain_list/", params));
        case 1:
        case "end":
          return _context269.stop();
      }
    }, _callee269);
  }));
  return _commit_domain_list.apply(this, arguments);
}
function get_link_interface_ip(_x271) {
  return _get_link_interface_ip.apply(this, arguments);
}
function _get_link_interface_ip() {
  _get_link_interface_ip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee270(params) {
    return _regeneratorRuntime().wrap(function _callee270$(_context270) {
      while (1) switch (_context270.prev = _context270.next) {
        case 0:
          return _context270.abrupt("return", $.getJSON("/v1/company/get_link_interface_ip/", params));
        case 1:
        case "end":
          return _context270.stop();
      }
    }, _callee270);
  }));
  return _get_link_interface_ip.apply(this, arguments);
}
function get_other_task(_x272) {
  return _get_other_task.apply(this, arguments);
}
function _get_other_task() {
  _get_other_task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee271(params) {
    return _regeneratorRuntime().wrap(function _callee271$(_context271) {
      while (1) switch (_context271.prev = _context271.next) {
        case 0:
          return _context271.abrupt("return", $.getJSON("/v1/company/get_other_task/", params));
        case 1:
        case "end":
          return _context271.stop();
      }
    }, _callee271);
  }));
  return _get_other_task.apply(this, arguments);
}
function create_other_task(_x273) {
  return _create_other_task.apply(this, arguments);
}
function _create_other_task() {
  _create_other_task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee272(params) {
    return _regeneratorRuntime().wrap(function _callee272$(_context272) {
      while (1) switch (_context272.prev = _context272.next) {
        case 0:
          return _context272.abrupt("return", $.post("/v1/company/create_other_task/", params));
        case 1:
        case "end":
          return _context272.stop();
      }
    }, _callee272);
  }));
  return _create_other_task.apply(this, arguments);
}
function delete_other_task(_x274) {
  return _delete_other_task.apply(this, arguments);
}
function _delete_other_task() {
  _delete_other_task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee273(params) {
    return _regeneratorRuntime().wrap(function _callee273$(_context273) {
      while (1) switch (_context273.prev = _context273.next) {
        case 0:
          return _context273.abrupt("return", $.post("/v1/company/delete_other_task/", params));
        case 1:
        case "end":
          return _context273.stop();
      }
    }, _callee273);
  }));
  return _delete_other_task.apply(this, arguments);
}
function get_link_ping_detect(_x275) {
  return _get_link_ping_detect.apply(this, arguments);
}
function _get_link_ping_detect() {
  _get_link_ping_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee274(params) {
    return _regeneratorRuntime().wrap(function _callee274$(_context274) {
      while (1) switch (_context274.prev = _context274.next) {
        case 0:
          return _context274.abrupt("return", $.getJSON("/v1/company/get_link_ping_detect/", params));
        case 1:
        case "end":
          return _context274.stop();
      }
    }, _callee274);
  }));
  return _get_link_ping_detect.apply(this, arguments);
}
function create_link_ping_detect(_x276) {
  return _create_link_ping_detect.apply(this, arguments);
}
function _create_link_ping_detect() {
  _create_link_ping_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee275(params) {
    return _regeneratorRuntime().wrap(function _callee275$(_context275) {
      while (1) switch (_context275.prev = _context275.next) {
        case 0:
          return _context275.abrupt("return", $.post("/v1/company/create_link_ping_detect/", params));
        case 1:
        case "end":
          return _context275.stop();
      }
    }, _callee275);
  }));
  return _create_link_ping_detect.apply(this, arguments);
}
function update_link_ping_detect(_x277) {
  return _update_link_ping_detect.apply(this, arguments);
}
function _update_link_ping_detect() {
  _update_link_ping_detect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee276(params) {
    return _regeneratorRuntime().wrap(function _callee276$(_context276) {
      while (1) switch (_context276.prev = _context276.next) {
        case 0:
          return _context276.abrupt("return", $.put("/v1/company/update_link_ping_detect/", params));
        case 1:
        case "end":
          return _context276.stop();
      }
    }, _callee276);
  }));
  return _update_link_ping_detect.apply(this, arguments);
}
function get_link_ping_detect_detail(_x278) {
  return _get_link_ping_detect_detail.apply(this, arguments);
}
function _get_link_ping_detect_detail() {
  _get_link_ping_detect_detail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee277(params) {
    return _regeneratorRuntime().wrap(function _callee277$(_context277) {
      while (1) switch (_context277.prev = _context277.next) {
        case 0:
          return _context277.abrupt("return", $.getJSON("/v1/company/get_link_ping_detect_detail/", params));
        case 1:
        case "end":
          return _context277.stop();
      }
    }, _callee277);
  }));
  return _get_link_ping_detect_detail.apply(this, arguments);
}
function check_manual_link_path(_x279) {
  return _check_manual_link_path.apply(this, arguments);
}
function _check_manual_link_path() {
  _check_manual_link_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee278(params) {
    return _regeneratorRuntime().wrap(function _callee278$(_context278) {
      while (1) switch (_context278.prev = _context278.next) {
        case 0:
          return _context278.abrupt("return", $.post("/v1/company/check_manual_link_path/", params));
        case 1:
        case "end":
          return _context278.stop();
      }
    }, _callee278);
  }));
  return _check_manual_link_path.apply(this, arguments);
}
function push_all_config(_x280) {
  return _push_all_config.apply(this, arguments);
}
function _push_all_config() {
  _push_all_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee279(params) {
    return _regeneratorRuntime().wrap(function _callee279$(_context279) {
      while (1) switch (_context279.prev = _context279.next) {
        case 0:
          return _context279.abrupt("return", $.post("/v1/company/push_all_config/", params));
        case 1:
        case "end":
          return _context279.stop();
      }
    }, _callee279);
  }));
  return _push_all_config.apply(this, arguments);
}
function get_device_export(_x281) {
  return _get_device_export.apply(this, arguments);
}
function _get_device_export() {
  _get_device_export = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee280(params) {
    return _regeneratorRuntime().wrap(function _callee280$(_context280) {
      while (1) switch (_context280.prev = _context280.next) {
        case 0:
          return _context280.abrupt("return", $.getJSON("/v1/company/get_device_export/", params));
        case 1:
        case "end":
          return _context280.stop();
      }
    }, _callee280);
  }));
  return _get_device_export.apply(this, arguments);
}
function switch_export(_x282) {
  return _switch_export.apply(this, arguments);
}
function _switch_export() {
  _switch_export = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee281(params) {
    return _regeneratorRuntime().wrap(function _callee281$(_context281) {
      while (1) switch (_context281.prev = _context281.next) {
        case 0:
          return _context281.abrupt("return", $.post("/v1/company/switch_export/", params));
        case 1:
        case "end":
          return _context281.stop();
      }
    }, _callee281);
  }));
  return _switch_export.apply(this, arguments);
}
function update_link_bandwidth(_x283) {
  return _update_link_bandwidth.apply(this, arguments);
}
function _update_link_bandwidth() {
  _update_link_bandwidth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee282(params) {
    return _regeneratorRuntime().wrap(function _callee282$(_context282) {
      while (1) switch (_context282.prev = _context282.next) {
        case 0:
          return _context282.abrupt("return", $.post("/v1/company/update_link_bandwidth/", params));
        case 1:
        case "end":
          return _context282.stop();
      }
    }, _callee282);
  }));
  return _update_link_bandwidth.apply(this, arguments);
}
function get_manual_path(_x284) {
  return _get_manual_path.apply(this, arguments);
}
function _get_manual_path() {
  _get_manual_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee283(params) {
    return _regeneratorRuntime().wrap(function _callee283$(_context283) {
      while (1) switch (_context283.prev = _context283.next) {
        case 0:
          return _context283.abrupt("return", $.getJSON("/v1/company/get_manual_path/", params));
        case 1:
        case "end":
          return _context283.stop();
      }
    }, _callee283);
  }));
  return _get_manual_path.apply(this, arguments);
}
function create_manual_path_config(_x285) {
  return _create_manual_path_config.apply(this, arguments);
}
function _create_manual_path_config() {
  _create_manual_path_config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee284(params) {
    return _regeneratorRuntime().wrap(function _callee284$(_context284) {
      while (1) switch (_context284.prev = _context284.next) {
        case 0:
          return _context284.abrupt("return", $.post("/v1/company/create_manual_path_config/", params));
        case 1:
        case "end":
          return _context284.stop();
      }
    }, _callee284);
  }));
  return _create_manual_path_config.apply(this, arguments);
}
function query_effect_info_list(_x286) {
  return _query_effect_info_list.apply(this, arguments);
}
function _query_effect_info_list() {
  _query_effect_info_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee285(params) {
    return _regeneratorRuntime().wrap(function _callee285$(_context285) {
      while (1) switch (_context285.prev = _context285.next) {
        case 0:
          return _context285.abrupt("return", $.getJSON("/v1/company/query_effect_info_list/", params));
        case 1:
        case "end":
          return _context285.stop();
      }
    }, _callee285);
  }));
  return _query_effect_info_list.apply(this, arguments);
}
function publish_effect_info(_x287) {
  return _publish_effect_info.apply(this, arguments);
}
function _publish_effect_info() {
  _publish_effect_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee286(params) {
    return _regeneratorRuntime().wrap(function _callee286$(_context286) {
      while (1) switch (_context286.prev = _context286.next) {
        case 0:
          return _context286.abrupt("return", $.post("/v1/company/publish_effect_info/", params));
        case 1:
        case "end":
          return _context286.stop();
      }
    }, _callee286);
  }));
  return _publish_effect_info.apply(this, arguments);
}
function sort_manual_config_id(_x288) {
  return _sort_manual_config_id.apply(this, arguments);
}
function _sort_manual_config_id() {
  _sort_manual_config_id = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee287(params) {
    return _regeneratorRuntime().wrap(function _callee287$(_context287) {
      while (1) switch (_context287.prev = _context287.next) {
        case 0:
          return _context287.abrupt("return", $.post("/v1/company/sort_manual_config_id/", params));
        case 1:
        case "end":
          return _context287.stop();
      }
    }, _callee287);
  }));
  return _sort_manual_config_id.apply(this, arguments);
}
function query_link_effect(_x289) {
  return _query_link_effect.apply(this, arguments);
}
function _query_link_effect() {
  _query_link_effect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee288(params) {
    return _regeneratorRuntime().wrap(function _callee288$(_context288) {
      while (1) switch (_context288.prev = _context288.next) {
        case 0:
          return _context288.abrupt("return", $.getJSON("/v1/company/query_link_effect/", params));
        case 1:
        case "end":
          return _context288.stop();
      }
    }, _callee288);
  }));
  return _query_link_effect.apply(this, arguments);
}
function get_alert_history_count(_x290) {
  return _get_alert_history_count.apply(this, arguments);
}
function _get_alert_history_count() {
  _get_alert_history_count = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee289(params) {
    return _regeneratorRuntime().wrap(function _callee289$(_context289) {
      while (1) switch (_context289.prev = _context289.next) {
        case 0:
          return _context289.abrupt("return", $.getJSON("/v1/company/alert/get_alert_history_count/", params));
        case 1:
        case "end":
          return _context289.stop();
      }
    }, _callee289);
  }));
  return _get_alert_history_count.apply(this, arguments);
}
function query_alert_history(_x291) {
  return _query_alert_history.apply(this, arguments);
}
function _query_alert_history() {
  _query_alert_history = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee290(params) {
    return _regeneratorRuntime().wrap(function _callee290$(_context290) {
      while (1) switch (_context290.prev = _context290.next) {
        case 0:
          return _context290.abrupt("return", $.getJSON("/v1/company/alert/query_alert_history/", params));
        case 1:
        case "end":
          return _context290.stop();
      }
    }, _callee290);
  }));
  return _query_alert_history.apply(this, arguments);
}
function query_alert_history_aggregate(_x292) {
  return _query_alert_history_aggregate.apply(this, arguments);
}
function _query_alert_history_aggregate() {
  _query_alert_history_aggregate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee291(params) {
    return _regeneratorRuntime().wrap(function _callee291$(_context291) {
      while (1) switch (_context291.prev = _context291.next) {
        case 0:
          return _context291.abrupt("return", $.getJSON("/v1/company/alert/query_alert_history_aggregate/", params));
        case 1:
        case "end":
          return _context291.stop();
      }
    }, _callee291);
  }));
  return _query_alert_history_aggregate.apply(this, arguments);
}
function get_queue_task(_x293) {
  return _get_queue_task.apply(this, arguments);
}
function _get_queue_task() {
  _get_queue_task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee292(params) {
    return _regeneratorRuntime().wrap(function _callee292$(_context292) {
      while (1) switch (_context292.prev = _context292.next) {
        case 0:
          return _context292.abrupt("return", $.post("/v1/task/get_queue_task/", params));
        case 1:
        case "end":
          return _context292.stop();
      }
    }, _callee292);
  }));
  return _get_queue_task.apply(this, arguments);
}
function purge_task(_x294) {
  return _purge_task.apply(this, arguments);
}
function _purge_task() {
  _purge_task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee293(params) {
    return _regeneratorRuntime().wrap(function _callee293$(_context293) {
      while (1) switch (_context293.prev = _context293.next) {
        case 0:
          return _context293.abrupt("return", $.post("/v1/task/purge_task/", params));
        case 1:
        case "end":
          return _context293.stop();
      }
    }, _callee293);
  }));
  return _purge_task.apply(this, arguments);
}
export { update_max_app_no, get_max_app_no, batch_update_device, get_manual_link_path, get_app_group, get_app_of_group, create_app_group, update_app_group, delete_app_group, add_app_for_group, remove_app_from_group, delete_domain_list, create_domain_list, get_domain_list, delete_domain_group, update_domain_group, create_domain_group, get_domain_group, get_ip_groups, get_company_log, delete_dpi_apps, update_dpi_apps, create_dpi_apps, create_dpi_apps_category, delete_dpi_apps_category, update_dpi_apps_category, get_dpi_apps_category, get_app_device, create_agency_group, update_agency_group, delete_agency_group, get_agency_group, delete_app_account, update_app_account, create_app_account, get_app_account, get_app_ipset, create_app_ipset, update_app_ipset, delete_app_ipset, delete_app_version_company, update_app_version_company, create_app_version_company, get_app_version_company, get_app_version, update_app_version, push_config, update_cpe_template_agency, get_cpe_template_agency, get_cpe_template, create_cpe_template, update_cpe_template, delete_cpe_template, get_lan_template, delete_client_auth, update_client_auth, get_client_auth, create_client_auth, get_wifi, get_wifi_config_file, set_backup_link, out_stock_batch, get_logo, get_device_version_list, send_command, delete_empty_link, get_script_list, update_link_batch, get_update_task_list, delete_device_model, update_device_model, create_device_model, get_device_model, delete_area, update_area, create_area, delete_address, update_address, create_address, get_area, get_address, get_manual_link_path_placeholder, exchange_device, get_redis_alarm_log, deal_alarm, get_redis_alarm_stat, move_device, batch_update_redis_alarm, get_redis_alarm, get_bandwidth_stat_all, get_device_type_stat, get_device_model_stat, get_request_log, get_tunnel_port, get_dpi_apps, delete_dpi_apps_custom, get_dpi_apps_custom, create_dpi_apps_custom, update_dpi_apps_custom, get_app_category, get_sn, update_stock_batch, get_isp_dict, update_isp_dict, add_isp_dict, delete_isp_dict, get_dep_tree, duplicate_cpe_template, update_department, update_password, reset_password, change_activity, delete_department, add_department, delete_related_person, create_related_person, delete_attachment, updateRelatedPerson, get_company_related_person, get_company_stat, delete_company, update_speed_rule, get_contract_list, update_contract, create_company_contract, create_company_related_person, create_company, get_related_person_list, update_company, update_deduplication, get_deduplication, create_manual_link_path, get_manual_link_path_example, get_topo_list, delete_device, get_wan_info, get_device_stat, delete_iptable, create_iptable, get_iptable_list, create_agency, delete_agency, delete_agency_batch, get_link_path, get_speed_rule, create_link_batch, get_link_list, delete_topo_batch, delete_topo, create_topo, delete_link, update_link, create_link, get_device_list, get_link, get_link_stat, get_black_list, delete_black_list, create_black_list, create_isp, create_room, update_isp, update_room, delete_isp, delete_room, get_isp_list, getRoomList, deleteStock, create_stock, get_room_list, get_agency_list, get_company_list, out_stock, update_stock, update_devices, update_device, getDeviceList, get_stock_stat, get_stock_list, batch_update_company, download_company_log, update_interface_detect, get_national_ip, get_bgp, create_bgp_normal, update_bgp_normal, delete_bgp_normal, get_cta_lan, get_port_detect, create_port_detect, update_port_detect, delete_port_detect, get_bgp_his, get_app_account_stat, get_uci_command, get_center_links_bandwidth_stat, get_bgp_ip, get_l3_tunnel, create_l3_tunnel, update_l3_tunnel, delete_l3_tunnel, reset_stock, get_device_lifetime, get_healthy_status, get_filter_rule, push_config_old, put_filter_rule, get_boss_uic_use, post_boss_uic_use, get_strategy_label, delete_filter_rule, get_deleted_link, get_all_alarms_count, post_all_alarms, get_company_url, update_company_url, get_app_account_group, get_resource_group, get_centre_agency, create_app_account_link, update_app_account_link, all_company_update, get_controllers, get_controller_companys, create_controller, update_controller, update_company_controller, delete_controller, get_bill_link_info, get_manual_strategy, get_area_info, get_device_sn, get_province_rooms, create_manual_strategy, delete_manual_strategy, update_manual_strategy, search_controller_company, check_move_device, get_dpi_feature, get_wan_isp_info, send_script_list, get_link_detect_info, create_link_detect_info, delete_link_detect_info, get_agency_ip_of_device, check_ip_in_agency_ip, get_agency_ip_of_link, get_agency_list_all, cstep_device_changed, get_port_series, get_app_log, create_static_domain_list, create_upgrade_record, get_update_device, upgrade_company, get_company_log_status, export_company_log, cancel_company_log, create_manual_link_path_bulk, create_script_file, update_script_file, delete_script_file, get_script_file, get_address_tree, post_display_manual_path, post_display_manual_path_bulk, create_reverse_tunnel, commit_domain_list, get_link_interface_ip, get_other_task, create_other_task, delete_other_task, get_link_ping_detect, create_link_ping_detect, update_link_ping_detect, get_link_ping_detect_detail, check_manual_link_path, delete_uci_command, push_all_config, get_device_export, switch_export, update_link_bandwidth, get_manual_path, create_manual_path_config, query_effect_info_list, publish_effect_info, sort_manual_config_id, query_link_effect, get_alert_history_count, query_alert_history, query_alert_history_aggregate, get_queue_task, purge_task };